import { Component, OnInit } from '@angular/core';
import { VehicleService } from '../../../vehicles/services/vehicle.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng-lts/api';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ReportService } from '../../services/report.service';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BrowserDetectorService } from '../../services/browser-detector.service';
import { EventService } from 'src/app/events/services/event.service';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { UserTracker } from 'src/app/multiview/models/interfaces';
import { Operator } from 'src/app/shared/models/interfaces';
import { OperatorService } from 'src/app/shared/services/operator.service';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { Driver, Ibutton } from 'src/app/drivers/models/interfaces';
// import { threadId } from 'worker_threads';
import { ReportPayload } from '../../models/report-payload';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionService } from 'src/app/permiss/permission.service';

declare var google: any;
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  reports: any = [];
  events: any = [];
  selectedReport: any = {};
  ListVehicles: any = [];
  vehicles: any = [];
  vehiclesCipia: any = [] // only cipia
  selectedVehicles: any = [];
  convoys: any = [];
  selectedConvoy: any = {};
  groups: any = [];
  selectedGroup: any = {};
  public isReportSupported = true;
  public isReportWithSummary = false;
  //para operaciones
  operations: any = [];
  selectedOperation: any = {};
  disabledOperation = false;
  disabledGroup = true;
  placeholderOperation = 'Seleccione una Operación ...';
  placeholderGroup = 'Seleccione una Operación Primero...';
  placeholderConvoy = 'Seleccione una Operación Primero...';
  disabledConvoy = true;
  listOptionCheckbox = 'all';
  listOptions: any = [
    { idOption: 'Mostrar Todos los Vehículos', valueOption: 'all' },
    { idOption: 'Operación', valueOption: 'operacion' },
    { idOption: 'Grupo', valueOption: 'grupo' },
    { idOption: 'Convoy', valueOption: 'convoy' }
  ];
  checkboxGroup: boolean = false;
  pDropdownGroup: any = [
    { label: 'Convoy', value: false },
    { label: 'Grupo', value: true },
    { label: 'Operacion', value: false }
  ];

  selectedDuracion: any;
  selectedToleracia: any;
  selectedDireccionZona: any;

  optionReportEvaluation: boolean | null = null;
  optionReportEventConfirmed: 'confirmed' | 'notconfirmed' | 'all' = 'all';
  optionReportEventEvaluation: 'true' | 'false' | 'null' = 'null';
  optionsLabelMap: Record<string, string> = {
    'true': 'Evaluados',
    'false': 'No evaluados',
    'null': 'Todos'
  };

  optionsEvaluationsLabel: any[] = [
    { label: 'Todos', value: 'null' },
    { label: 'Evaluados', value: 'true' },
    { label: 'No Evaluados', value: 'false' }
  ];

  optionsConfirmedLabel: any[] = [
    { label: 'Todos', value: 'all' },
    { label: 'Confirmados', value: 'confirmed' },
    { label: 'No confirmados', value: 'unconfirmed' }
  ];
  optionReportEvaluationLabel: string = this.optionsLabelMap[String(this.optionReportEvaluation)];

  listOptionsDuracion: any = [
    // { name: '0 segundos', code: '0' },
    { name: '15 segundos', code: 15 },
    { name: '30 segundos', code: 30 },
    { name: '45 segundos', code: 45 },
    { name: '60 segundos', code: 60 }
  ];
  listOptionsToleracia: any = [
    // { name: 'Toleracia 0', code: '0' },
    { name: '3 km/h', code: 3 },
    { name: '5 km/h', code: 5 },
    { name: '10 km/h', code: 10 }
  ];
  listOptionsDireccion: any = [
    // { name: 'Toleracia 0', code: '0' },
    { name: 'SUBIDA', code: 'SUBIDA' },
    { name: 'BAJADA', code: 'BAJADA' },
  ];
  chkRiesgo = true;

  /* checkboxParada: boolean = true; //Renamed to chkStops
  checkboxMovimiento: boolean = true; */ //Renamed to chkMovements
  // checkboxDuracion: boolean = false; //Renamed to chkDuracion
  dateInit!: Date;
  dateEnd!: Date;
  timeInit!: Date;
  timeEnd!: Date;

  zones: any = [];
  listTags: any = [];
  /* changedReport = changedReport();
  onGenerate = onGenerate();
  showConfirm = showConfirm();
  clearSearchTermVehicle = clearSearchTermVehicle();
  clearSearchTermConvoy = clearSearchTermConvoy();
  clearSearchTermGroup = clearSearchTermGroup();
  clearSearchTermZone = clearSearchTermZone();
  checkAllVehicles = checkAllVehicles();
  checkAllConvoys = checkAllConvoys();
  checkAllGroups = checkAllGroups();
  checkAllZones = checkAllZones();
  //checkForGroup = checkForGroup;
  closeSidebar = closeSidebar(); */
  isUserGeneral = true; // usar en caso use reportes para un usuario comun
  //selectedVehicle: any=[];
  //selectedConvoy: any=[];
  //selectedGroup: any=[];
  //selectedZone: any=[]; //Replaced by selectedZones
  //showLimitSpeed = false; //Replaced by showExcVelOpt

  //showZones = false;
  showCheckboxs = false;
  showCheckboxsCipia = false;
  showTipoExcesoVelocidad = false;
  showOperatividadEquipos = false;
  showExcesoNivelDuracion = false;
  showDireccionGeocerca = false;
  showParadasMovimientos = false;
  

  showCard = false;
  showDivHorizontal = false;
  showOnlyEvents = false;
  showEvents = false;
  showEventsCipia = false;
  showAtencionEventsCipia = false;

  showSubLimitTime = false;
  showTrans1min = false;
  showFatigaOp = false;
  //showFrenadaAceleracionOp = false; //Renamed to showBrakeAccel
  disableVehicle = false;
  disableConvoy = false;
  disableGroup = false;
  disableButton = false;
  initialDate = new Date();
  finishedDate = new Date();
  initialHour = "00";
  initialMinute = "00";
  finishedHour = "23";
  finishedMinute = "59";
  fullScreenSpinnerMsg: string = 'Finalizando carga...';

  strYearRange: string = '';

  //Popup
  popupIconSrc = './assets/images/popup-icon-chrome.svg';
  popupDialogPosition: string = 'top-right';
  popupDialogInlineStyle: any = {};
  isChrome: boolean = false;
  isFirefox: boolean = false;
  isSafari: boolean = false;
  isOpera: boolean = false;
  isEdge: boolean = false;
  isIEEdge: boolean = false;
  unknownBrowser: boolean = false;

  reportType = "0";
  toggleConvoy = true;
  toggleGrupo = false;
  chkAllVehicles = false;
  chkAllZones = false;
  chkAllTags = false;
  showBlockedTabDialog = false;
  showCombustibleOpt = false;
  showMonitoreoResumenXDia = false;

  showLimitTime = false;
  showVehiclesCipia = false; // si es false mostrar todos lo vehiculos
  areVehiclesLoaded = false;
  areZonesLoaded = false;
  areTagsLoaded = false;
  isUserIdLoaded = false;
  errorFlag = 0;

  //Reporte 0 - Paradas y Movi
  chkStops: boolean = true;
  chkMovements: boolean = true;
  showMovStop = false;

  //Reporte 1 - Exceso de Vel
  showExcVelOpt: boolean = false;
  checkboxDuration: boolean = false;
  minimDur = 15;
  limitSpeed = 90;

  pDropdownDuration: any = [
    { label: 'Límite de Velocidad', value: true },
  ];

  //Reporte 2 - Entrada y Salida
  showZones: boolean = false;
  showTagsZones: boolean = false;
  showTagGeocercaOrGeocerca: boolean = false;
  selectedZones: any = [];
  selectedTags: any = [];

  //Reporte 3 - Combustible
  showOdomOpt: boolean = false;
  chkOdomVirtual: boolean = false;
  odometroVirtual: number = 0;

  chkCombustibleResumen: boolean = false;
  chkCombustibleDetallado: boolean = true;

  chkResumenEvXUnidades: boolean = true;
  chkResumenEvXZonas: boolean = false;

  //Reporte 4 - Frenada y Aceleracion Brusca
  showBrakeAccel: boolean = false;
  chkFrenada = true;
  chkAceleracion = true;

  //Reporte 5 - Reporte General
  oG = {
    DUOT2state: false, // --- NEW2
    RPMAlta: false,
    RxM: false,
    aBrusca: false,
    alcoholemia: false,
    altitud: false,
    angulo: false,
    cMotor: false,
    cRestante: false, // --- NEW
    fBrusca: false,
    fExBrusca: false,
    fServidor: false,   // --- NEW
    fatiga: false,
    cNivel: false,  //  NEW
    odometro: false,
    onOff: false,
    pCercano: false,
    parametros: false,  // --- NEW
    recFacial: false,
    referencia: false,
    ubicacion: false,
    velCAN: false,
    velECO: false,
    velGPS: false,
    velGPS_speed: false,
    velMobileye_ME460: false,
    errorMobileye_ME427: false,
    alimentGps: false,
    nivelBateria: false,
    nivelCobertura: false,
    temperaturaGps: false,
    satelite: false,
    bleTemperature: false,
    eyeTemperature: false,
    eyeHumedad: false,
    bleHumedad: false,
    geocerca: false,
    direccionGeocerca: false,
    voltageLevel: false,
  };

  // PARA CONTROLADR CUALES EVENTOS MOSTRAR
  eventsTypes: any[] = [
    { name: 'gps', active: false, label: 'GPS', selectAll: false },
    { name: 'platform', active: false, label: 'PLATAFORMA', selectAll: false },
    { name: 'security', active: false, label: 'SEGURIDAD VEHICULAR', selectAll: false },
    { name: 'mobile', active: false, label: 'SOLUCIONES MÓVILES', selectAll: false },
    { name: '360', active: false, label: 'FATIGA 360', selectAll: false },
  ];
  //LISTA DE EVENTOS MARCADOS POR DEFECTO
  evCheckDefault = {
    AccFatiga: true,
    // AccTest: true,
  };
  //Reporte 6 - Reporte de Eventos
  eV: { [key: string]: boolean } = {};

  //Reporte 6 - Reporte de Eventos , Seleccion de Campo
  eC = {
    Fecha: true,
    Hora: false,
    FechaServidor: false,
    NombreEvento: true,
    Evento: true,
    Codigo: true,
    Placa: true,
    TipoUnidad: false,
    IdConductor: false,
    Conductor: false,

    FechaEvaluacion: false,
    CriterioEvaluacion: false,
    Observacion: false,
    Validacion: false,

    VelMobileye: false,
    VelGPS: true,
    VelCAN: false,
    VelECO: false,
    VelGPSspeed: false,

    Zona: false,
    PuntoCercano: false,
    Ubicacion: false,
    Referencia: false,
    EnlaceArchivo: false,
    Parametros: false,
    Satelite: false,
    ComRadial: false,
    ConMasDetalle: false,
    OperadorMonitoreo: false,  // R. Atención de Eventos
    humedad: false,
    temperatura: false,

    estadoGPS: false,
    estadoCipia: false,
    campoFatiga: false,
    campoCaredrive: false,
    campoCAN: false,
    campoADAS: false,
    campoAlcotester: false,

    campoGerencia: false,
    campoRuta: false,
    campoDuracion: false,
    VelMaxima: false,
    Niveles: false,
    campoFalta: false,

    newDriver: false,

    //campoDuracion: false,
    campoDistancia: false,
    VelMaxGPS: false,
    VelMaxCAN: false,
    //Zona: false,
    //PuntoCercano: false,
    VelPromGPS: false,
    VelPromCAN: false,
    //Ubicacion: false,
    //Referencia: false,

  }
  userLineaIDs: number[] = [945, 946, 947, 956, 958]; //928,935,

  //Reporte 10 - Distraccion y Posible Fatiga
  showFatigaDistraccion: boolean = false;

  chkFatigaSomnolencia = true;
  chkFatigaDistraccion = true;

  chkTrans1min = false;

  spinnerOptions = false;

  newWindow = false;

  isFormFilled = false;
  areDatesValid = true;
  areHoursValid = true;

  chkSimultaneousTables: boolean = true;
  chkOnlyTables: boolean = false;
  showChkSimultaneousTables: boolean = false;
  singleTableReportIDs = ['R008', 'R020', 'R021'];

  //Removido del formulario
  chkDateHour = true; //False muestra fecha y h juntas. true separadas
  arrayUsers = [472, 204, 483, 467, 360, 394, 364, 445, 489, 491, 503, 504, 515, 522, 537, 554, 552, 555, 573, 587, 529, 590, 591, 595, 613, 620, 621, 734];
  fog = "1";
  userId = 0;

  isEverythingLoaded: boolean = false;

  optionOperators: Operator[] = [];

  constructor(
    private browserDetectorService: BrowserDetectorService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public reportService: ReportService,
    public confirmationService: ConfirmationService,
    private http: HttpClient,
    public operatorService: OperatorService,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private permissionService: PermissionService
  ) {
    //INICIAR EL VEHICLE SERVICE PARA REPORTES
    this.getUserData().then(() => {
      this.getAllDrivers()
      this.getIbuttonAll();
      //this.vehicleService.initialize();
      this.initVehicle()
    })
    spinner.show("fullScreenSpinner");
    this.titleService.setTitle('Reportes');

    // EN ESPERA DE USAR OPERADORES DE PANEL ADMIN
    this.operatorService.initialize();
    this.operatorService.dataComplete.subscribe(operators => {
      operators.forEach((item: Operator) => {
        const newItem: Operator = { label: item.label, value: item.label, };
        this.optionOperators.push(newItem);
      });
      console.log('OPERADORES LISTOS', this.optionOperators);
    })

    this.http.post(environment.apiUrl + '/api/getReports', {}).subscribe({
      next: data => {
        // console.log(this.selectedConvoy.length);
        console.log("----------------data");
        console.log(data);
        this.reports = data;
        this.reportService.listReportes = this.reports;

        // this.reports = [
        //     {
        //         bol_eliminado: false,
        //         codigo: "R006",
        //         descripcion: "",
        //         id: 1,
        //         url: "/api/reports/general",
        //         value: "REPORTE GENERAL",
        //     },
        //     {
        //         bol_eliminado: false,
        //         codigo: "R049",
        //         descripcion: "",
        //         id: 2,
        //         url: "/api/reports/monitoreo_cantidad_eventos_unidad",
        //         value: "REPORTE MONITOREO CANTIDAD DE EVENTOS POR UNIDAD",
        //     },
        //   ];

        // this.reportService.listReportes = this.reports;
        // console.log(this.reports);

      },
      error: () => {
        console.log('Hubo un error al procesar la solicitud');
      }
    });
  }


  async reducedInfoVehicles(vehicles: any) {
    // Reducir y especificar la cantidad de informacion a enviar por vehiculo
    const reducedVehicles = vehicles.map((vh: UserTracker) => {
      return {
        IMEI: vh.IMEI,
        name: vh.name,
        driver_id: vh.driver_id,
        namegrupo: vh.namegrupo,
        idgrupo: vh.idgrupo,
        nameconvoy: vh.nameconvoy,
        idconvoy: vh.idconvoy,
        nameoperation: vh.nameoperation,
        idoperation: vh.idoperation,
        tipo: vh.tipo,
      };
    });
    return reducedVehicles;
  }

  public isShowImagesDisabled = true;
  public showImages = true;
  public onShowImagesChange(value: any) {
    this.reportService.setShowImagesChecklist(value);
  }

  ngOnInit(): void {

    this.reportService.reportFinished.subscribe((finished: boolean) => {
      if (finished) {
        this.isShowImagesDisabled = false
      }
    })

    //LISTA DE EVENTOS
    this.eventServiceLite.getEventsForUser().subscribe(
      async (data) => {
        // Aquí puedes trabajar con los datos obtenidos
        console.log('EVENTOS DEL USUARIO OBTENIDOS: 1vez', data);
        // Realiza cualquier acción con los datos recibidos
        if (data.success) {
          this.events = data.data || [];
          this.events = this.events.map((event: any) => {
            return { ...event, active: false };
          });
          this.updateShowTypeEvents();
        } else {
          this.events = [];
          console.log('EL USUARIO NO TIENE EVENTOS');
        }
      },
      (error) => {
        // Maneja los errores si ocurre alguno durante la solicitud
        console.error('Error al obtener los eventos:', error);
      }
    );

    let typeParam = this.route.snapshot.queryParamMap.get('type') || null
    if (typeParam) {
      this.selectedReport = typeParam;
      this.resetAllFields(); this.changedReport(); this.validateForm();
    }


    let withRiesgo = this.route.snapshot.queryParamMap.get('riesgo');
    if (withRiesgo) {
      this.chkRiesgo = withRiesgo === 'true';
    }

    let fromDate = this.route.snapshot.queryParamMap.get('from');
    let toDate = this.route.snapshot.queryParamMap.get('to');

    this.strYearRange = '2000:' + new Date().getFullYear();

    // lógica por defecto
    const hoy = Date.now();
    this.dateInit = new Date(moment(hoy).format("MM/DD/YYYY"));
    this.dateEnd = this.dateInit;

    this.timeInit = new Date('12/03/2018 00:00');
    this.timeEnd = new Date('12/03/2018 23:59');

    // 🔹 si viene FROM en la URL
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);


      if (from < to) {
        const MAX_RANGE_MS = 21 * 24 * 60 * 60 * 1000;
        const diffMs = to.getTime() - from.getTime();

        if (diffMs <= MAX_RANGE_MS) {
          this.dateEnd = new Date(
            to.getFullYear(),
            to.getMonth(),
            to.getDate()
          );

          this.timeEnd = new Date(
            2018, 11, 3, // fecha dummy
            to.getHours(),
            to.getMinutes()
          );
          this.dateInit = new Date(
            from.getFullYear(),
            from.getMonth(),
            from.getDate()
          );

          this.timeInit = new Date(
            2018, 11, 3, // fecha dummy
            from.getHours(),
            from.getMinutes()
          );
        }
      }
    }


    console.log('funcion on init');
    console.log(this.reportType);
    this.spinnerOptions = true;
    this.setTimeZoneDefault();

    this.http.get<any>(environment.apiUrl + '/api/zone').subscribe({
      next: data => {
        this.zones = data.data;
        console.log("geocercas 'zones' ", this.zones);
        this.areZonesLoaded = true;
        this.endInit();
      },
      error: () => {
        console.log('Fallo al obtener geocercas');
        this.errorFlag++;
        this.endInit('Ha ocurrido un problema al intentar obtener las geocercas. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.');
      }
    });

    this.http.get<any>(environment.apiUrl + '/api/listTags').subscribe({
      next: data => {
        this.listTags = data.data;
        console.log("listTags", this.listTags);
        this.areTagsLoaded = true;
        this.endInit();
      },
      error: () => {
        console.log('Fallo al obtener listTags');
        this.errorFlag++;
        this.endInit('Ha ocurrido un problema al intentar obtener la lista de etiquetas. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.');
      }
    });




    this.http.get(environment.apiUrl + '/api/userId').subscribe({
      next: data => {
        this.userId = parseInt(JSON.stringify(data));
        this.reportService.setUserId(this.userId);
        console.log("user ID", this.userId);
        this.isUserIdLoaded = true;

        // ================= CAMPO PARA COLOCAR LOS REPORTES =========================
        // this.reports = [
        //   {id : 0, value : 'REPORTE DE PARADAS Y MOVIMIENTOS', url: '/api/reports/paradas_movimientos'},
        //   {id : 1, value : 'REPORTE DE EXCESOS DE VELOCIDAD', url: '/api/reports/exceso_velocidad'},
        // ];



        // ================= CAMPO PARA COLOCAR LOS REPORTES =========================

        this.endInit();
      },
      error: () => {
        console.log('Fallo al obtener userId');
        this.errorFlag++;
        this.endInit('Ha ocurrido un problema al intentar obtener la información del usuario. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.');
      }
    });

    if (this.browserDetectorService.isChromium()) {
      if (this.browserDetectorService.isOpera()) {
        this.isOpera = true;
      } else if (this.browserDetectorService.isChEdge()) {
        this.isEdge = true;
      } else {
        this.isChrome = true;
      }
      this.popupDialogPosition = 'top-right';
      this.popupDialogInlineStyle = { 'width': '20vw', 'min-width': '275px', 'max-width': '325px' };
    } else if (this.browserDetectorService.isFirefox()) {
      this.isFirefox = true;
      this.popupDialogPosition = 'top-left';
      this.popupDialogInlineStyle = { 'width': '45vw', 'min-width': '275px', 'max-width': '550px' };
    } else if (this.browserDetectorService.isSafari()) {
      console.log('arrives here');
      this.isSafari = true;
      this.popupDialogPosition = 'top';
      this.popupDialogInlineStyle = { 'width': '40vw', 'min-width': '225px' };
    } else {
      this.unknownBrowser = true;
      this.popupDialogPosition = 'center';
      this.popupDialogInlineStyle = { 'width': '50vw', 'min-width': '275px', 'max-width': '550px' };
    }

    console.log("Es chrome ? " + this.isChrome);
    console.log("Es opera ? " + this.isOpera);
    console.log("Es IE edge ? " + this.isIEEdge);
    console.log("Es Ch Edge ? " + this.isEdge);
    console.log("Es firefox ? " + this.isFirefox);
    console.log("Es safari ? " + this.isSafari);


    //this.reportService.eC = this.eC;

    // // console.log("fnc_direccion--xDs");
    // var f = new google.maps.Geocoder();
    // // var h = new google.maps.LatLng(trama.lat, trama.lng);
    // var h = new google.maps.LatLng(-16.406578,-71.560808);

    // f.geocode({
    // 		'latLng': h
    // },  (a:any, b:any) => {
    // 		console.log("*********************1");
    // 		console.log(a);
    // 		console.log(b);
    // 		console.log("*********************2");
    // 		if (b == "REQUEST_DENIED") {
    // 			// vm.chkApiGoogle = false;
    // 		} else {
    //       this.reportService.setApiGoogle(true);
    // 		}
    // });


  }

  lineaUser(): boolean {
    //let id: number = this.userDataService.userData.id_usu??this.userDataService.userData.id
    let id: number = this.userData.id_usu ?? this.userData.id
    return this.userLineaIDs.includes(id)
  }

  updateCheckDefaultEvents() {
    // Itera sobre las propiedades del objeto evCheckDefault si existe
    if (this.evCheckDefault) {
      for (const index in this.evCheckDefault) {
        const eventsToUpdate = this.events.find((ev: { name_form: string; }) => ev.name_form == index);
        if (eventsToUpdate) {
          eventsToUpdate.active = true;
        }
      }
      this.onChangeChkEvents();
    }
  }

  onSelectAllChange(type: any): void {
    const filteredEvents = this.events.filter((event: { event_category: any; }) => event.event_category === type.name);
    for (const event of filteredEvents) {
      event.active = type.selectAll;
    }
    this.onChangeChkEvents();
  }

  updateShowTypeEvents() {
    this.events.forEach((event: any) => {
      const eventsTypesToUpdate = this.eventsTypes.find(type => type.name === event.event_category);
      if (eventsTypesToUpdate) {
        eventsTypesToUpdate.active = true;
      }
    });
    console.log('test types -->', this.eventsTypes, this.events);
  }
  endInit(msm: string = 'Hubo un error al obtener la información. Por favor, actualiza la página. Si el problema persiste, póngase en contacto con el área de TI.') {
    if (this.errorFlag == 1) {
      this.spinner.hide("fullScreenSpinner");
      console.log('Hubo un error al obtener los datos');
      Swal.fire({
        title: 'Error',
        text: `${msm}`,
        icon: 'error',
        allowOutsideClick: false,
        confirmButtonText: 'Actualizar Página',
      }).then((data) => {
        if (data.isConfirmed) {
          this.spinner.show('reloadSpinner');
          window.location.reload();
        }
      });
      return;
    }
    if (this.errorFlag == 0 && this.areVehiclesLoaded && this.areZonesLoaded && this.isUserIdLoaded) {
      this.isEverythingLoaded = true;
      this.spinner.hide("fullScreenSpinner");
      this.fullScreenSpinnerMsg = '';
    }
  }
  waitInit(msm: string = 'Por favor, revise sus opciones y asegúrese de seleccionar al menos una antes de continuar.') {
    this.spinner.hide("fullScreenSpinner");
    console.log('Hubo un error al obtener los datos');
    Swal.fire({
      title: 'Advertencia',
      text: `${msm}`,
      icon: 'warning',
      allowOutsideClick: false,
      confirmButtonText: 'Entendido',
    }).then(() => {
      this.reportService.workingOnReport ? this.reportService.workingOnReport = false : null;
    })
    return;
  }
  //funciones para operaciones / grupos / convoys

  onOptionSelected() {

    let aux: any[] = [];
    aux = this.ListVehicles
    for (const vehicle of aux) {
      const id_operation = vehicle.idoperation;
      // const id_grupo = vehicle.idgrupo;
      // const id_convoy = vehicle.idconvoy;
      const filteredOperation = {
        idoperation: vehicle.idoperation,
        nameoperation: vehicle.nameoperation,
      };
      // const filteredConvoy = {
      //   idconvoy: vehicle.idconvoy,
      //   nameconvoy: vehicle.nameconvoy,
      //   idgrupo: vehicle.idgrupo,
      //   namegrupo: vehicle.namegrupo,
      //   idoperation: vehicle.idoperation,
      //   nameoperation: vehicle.nameoperation,
      // };
      // const filteredGroup = {
      //   idgrupo: vehicle.idgrupo,
      //   namegrupo: vehicle.namegrupo,
      //   idoperation: vehicle.idoperation,
      //   nameoperation: vehicle.nameoperation,
      // };
      if (!this.operations.some((op: any) => op.idoperation === id_operation)) {
        this.operations.push(filteredOperation);
      }
      // if (!this.convoys.some((cv:any) => cv.idconvoy === id_convoy)) {
      //   this.convoys.push(filteredConvoy);
      // }
      // if (!this.groups.some((gp:any) => gp.idgrupo === id_grupo)) {
      //   this.groups.push(filteredGroup);
      // }
    }
    this.operations.sort((a: { idoperation: number; }, b: { idoperation: number; }) => a.idoperation - b.idoperation);
    // this.groups.sort((a: { idgrupo: number; }, b: { idgrupo: number; }) => a.idgrupo - b.idgrupo);
    // this.convoys.sort((a: { idconvoy: number; }, b: { idconvoy: number; }) => a.idconvoy - b.idconvoy);
    console.log('Operations: ', this.operations);
    // console.log('Convoys: ',this.convoys);
    // console.log('Groups: ',this.groups);

    //actualizar lista de vehiculos
    this.vehicles = this.ListVehicles;
    this.loadVehiclesCipia();
    this.disabledGroup = true;
    this.disabledConvoy = true;
    this.groups = [];
    this.convoys = [];
    this.selectedOperation = '';
    this.selectedGroup = '';
    this.selectedConvoy = '';
    this.placeholderOperation = 'Seleccione una Operación ...';
    this.placeholderGroup = 'Seleccione una Operación Primero...';
    this.placeholderConvoy = 'Seleccione una Operación Primero...';
  }
  onChangeOperation() {
    this.selectedGroup = '';
    this.selectedConvoy = '';
    this.groups = [];
    this.convoys = [];
    this.vehicles = [];
    this.selectedVehicles = [];
    let aux: any[] = [];
    let aux2: any[] = [];

    if (this.listOptionCheckbox == 'grupo' || this.listOptionCheckbox == 'convoy') {
      //filtrar grupos en base a operacion seleccionada
      aux = this.ListVehicles.filter((gp: any) => gp.idoperation == this.selectedOperation);
      for (const vehicle of aux) {
        const id_grupo = vehicle.idgrupo;
        const filteredGroup = {
          idgrupo: vehicle.idgrupo,
          namegrupo: vehicle.namegrupo,
          idconvoy: vehicle.idconvoy,
          nameconvoy: vehicle.nameconvoy,
          idoperation: vehicle.idoperation,
          nameoperation: vehicle.nameoperation,
        };
        if (!this.groups.some((gp: any) => gp.idgrupo === id_grupo)) {
          this.groups.push(filteredGroup);
        }
      }
      this.groups.sort((a: { idgrupo: number; }, b: { idgrupo: number; }) => a.idgrupo - b.idgrupo);

      this.disabledGroup = false;
      this.placeholderGroup = 'Seleccione un Grupo...';
      this.placeholderConvoy = 'Seleccione un Grupo Primero...';
    }
    //filtrar vehiculos
    aux2 = this.ListVehicles.filter((vh: any) => vh.idoperation == this.selectedOperation);
    this.vehicles = aux2;
    this.loadVehiclesCipia();
    this.chkAllVehicles = false;
    this.showChkSimultaneousTables = this.vehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;

    console.log('Groups: ', this.groups);
    console.log('Vehicles: ', this.vehicles);

  }
  onChangeGroup() {
    this.selectedConvoy = '';
    this.convoys = [];
    this.vehicles = [];
    this.selectedVehicles = [];

    let aux: any[] = [];
    let aux2: any[] = [];

    if (this.listOptionCheckbox == 'convoy') {
      //filtrar grupos en base a operacion seleccionada
      aux = this.ListVehicles.filter((cv: any) => cv.idgrupo == this.selectedGroup && cv.idoperation == this.selectedOperation);
      for (const vehicle of aux) {
        const id_convoy = vehicle.idconvoy;
        const filteredGroup = {
          idgrupo: vehicle.idgrupo,
          namegrupo: vehicle.namegrupo,
          idconvoy: vehicle.idconvoy,
          nameconvoy: vehicle.nameconvoy,
        };
        if (!this.convoys.some((cv: any) => cv.idconvoy === id_convoy)) {
          this.convoys.push(filteredGroup);
        }
      }
      this.disabledConvoy = false;
      this.placeholderConvoy = 'Seleccione un Convoy..';
      this.convoys.sort((a: { idconvoy: number; }, b: { idconvoy: number; }) => a.idconvoy - b.idconvoy);
    }

    //filtrar vehiculos
    aux2 = this.ListVehicles.filter((vh: any) => vh.idgrupo == this.selectedGroup && vh.idoperation == this.selectedOperation);
    this.vehicles = aux2;
    this.loadVehiclesCipia();
    // for (const vehicle of aux2) {
    //   const id_operation = vehicle.idoperation;

    //   if (!this.vehicles.some((vh:any) => vh.idoperation === id_operation)) {
    //     this.vehicles.push(vehicle);
    //   }
    // }
    this.chkAllVehicles = false;
    this.showChkSimultaneousTables = this.vehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;

    console.log('Convoys: ', this.convoys);
    console.log('Vehicles: ', this.vehicles);
  }
  onChangeConvoy() {
    this.vehicles = [];
    this.selectedVehicles = [];
    let aux: any[] = [];
    aux = this.ListVehicles.filter((vh: any) => vh.idconvoy == this.selectedConvoy && vh.idgrupo == this.selectedGroup && vh.idoperation == this.selectedOperation);
    this.vehicles = aux;
    this.loadVehiclesCipia();

    this.chkAllVehicles = false;
    this.showChkSimultaneousTables = this.vehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;

    console.log('Vehicles: ', this.vehicles);
  }

  onchangeDuracion() {
    console.log(this.selectedDuracion);
    console.log(this.selectedToleracia);
    console.log(this.chkRiesgo);
    console.log(this.selectedDireccionZona);

  }

  selectAllVehicles() {
    this.selectedVehicles = this.chkAllVehicles ? this.vehicles : [];
    this.onSelectedVehiclesChange();
  }

  changeCheckResumenXDia(tipo: number) {
    // 1=unidad -- 2=zona
    if (tipo == 1) {
      this.chkResumenEvXZonas = !this.chkResumenEvXUnidades;
    } else if (tipo == 2) { this.chkResumenEvXUnidades = !this.chkResumenEvXZonas; }
  }

  changeTagGeocercaOrGeocerca(tipo: number) {
    // 1=Etiquetas -- 2=Geocercas
    if (tipo == 1) {
      this.showZones = !this.showTagsZones;
      this.selectedZones = [];
    } else if (tipo == 2) {
      this.showTagsZones = !this.showZones;
      this.selectedTags = [];
    }
  }

  selectAllZones() {
    this.selectedZones = this.chkAllZones ? this.zones.map((zone: { id: any; }) => { return zone.id }) : [];
  }

  selectAllTags() {
    this.selectedTags = this.chkAllTags ? this.listTags.map((tag: { id: any; }) => { return tag.id }) : [];
  }


  async getConfirm() {
    const now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);

    const intervalDays = async () => {
      if (await this.permissionService.hasPermission('Report_interval_31')) {
        return 31;
      }
      if (await this.permissionService.hasPermission('Report_interval_20')) {
        return 20;
      }
      return 15;
    };
    const time = async () => {
      if (await this.permissionService.hasPermission('Report_limit_730')) {
        return 730;
      }
      if (await this.permissionService.hasPermission('Report_limit_547')) {
        return 547;
      }
      return 365;
    };
    const limit: Record<string, number> = {
      day: 1000 * 60 * 60 * 24,
      Days: await intervalDays(),
      Time: await time(),
    };
    if (Math.abs(this.dateInit.getTime() - now.getTime()) / limit.day > limit.Time) {
      this.waitInit(`No es posible seleccionar fechas con un intervalo superior a ${limit.Time} días. Por favor, elija fechas dentro del límite permitido.`);
      return;
    }
    if ((Math.abs(this.dateEnd.getTime() - this.dateInit.getTime()) / limit.day) > limit.Days) {
      this.waitInit(`El intervalo de tiempo seleccionado excede los ${limit.Days} días. Por favor, verifíquelo e inténtelo nuevamente.`);
      return;
    }
    console.log('from time: start', this.timeInit, this.timeEnd);
    if (this.selectedVehicles.length == 0) {
      this.waitInit('Seleccione al menos un vehículo e inténtelo nuevamente.');
      return;
    }
    const reportCode: Record<string, string[]> = {
      'oG': ['R006'],
      'eV': ['R037', 'R038', 'R040'],
      'eC': ['R037', 'R038', 'R040', 'R041', 'R044']
    }
    if ((reportCode.oG.includes(this.selectedReport) && !Object.values(this.oG).some(value => value === true)) ||
      (reportCode.eV.includes(this.selectedReport) && !Object.values(this.eV).some(value => value === true)) ||
      (reportCode.eC.includes(this.selectedReport) && !Object.values(this.eC).some(value => value === true))) {
      const waitMessage: Record<string, string> = {
        'R006': 'una opción',
        'R037': 'un evento',
        'R038': 'un evento',
        'R040': 'un evento',
        'R041': 'una opción',
        'R044': 'una opción',
      }
      this.waitInit(`Seleccionar al menos ${waitMessage[this.selectedReport]} e inténtelo nuevamente.`);
      return;
    }
    this.isFormFilled = false;
    Swal.fire({
      // title: 'Título de la Alerta',
      text: '¿Desea generar el reporte en una nueva ventana?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#30a9d9',
      cancelButtonText: 'No',
      cancelButtonColor: '#e3e3e3',
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log('Sí');
        this.fullScreenSpinnerMsg = 'Generando Reporte...';
        this.spinner.show("fullScreenSpinner");
        console.log("Se acepta una nueva hoja");
        console.log('Cargando...');
        this.reportar(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // console.log('No');
        this.spinner.show("reportSpinner");
        console.log("Reporte en la misma hoja");
        this.reportar();
      } else {
        //CUANDO ES ESC O X
        console.log('Cancel');
        this.isFormFilled = true;
      }
    });
  }

  confirm() {
    this.isFormFilled = false;
    this.confirmationService.confirm({
      key: 'newTabConfirmation',
      /* header: 'Confirmación',
      acceptLabel: 'Sí',
      rejectLabel: 'No', */
      message: '¿Desea generar el reporte en una nueva ventana?',
      reject: () => {
        this.spinner.show("reportSpinner");
        console.log("Reporte en la misma hoja");
        this.reportar();
      },
      accept: () => {
        this.fullScreenSpinnerMsg = 'Generando Reporte...';
        this.spinner.show("fullScreenSpinner");
        console.log("Se acepta una nueva hoja");
        console.log('Cargando...');
        //undefined o true reportan en la misma pestaña. false reporta en nueva pestaña
        this.reportar(false);
      }
    });
  }

  reportar(new_tab?: any) {
    this.isShowImagesDisabled = true;
    this.showImages = true;
    this.reportService.eC = JSON.parse(JSON.stringify(this.eC));
    this.reportService.chkRiesgo = this.chkRiesgo;

    console.log(new_tab !== undefined);
    this.reportService.workingOnReport = true;

    var repSubtitle = '';
    var chkDateHour = this.chkDateHour;
    var chkFatigaSomnolencia = this.chkFatigaSomnolencia;
    var chkFatigaDistraccion = this.chkFatigaDistraccion;

    var chkDuracion = this.checkboxDuration;
    var chkOdomV = this.chkOdomVirtual;
    var chkFrenada = this.chkFrenada;
    var chkAceleracion = this.chkAceleracion;


    var f1 = moment(new Date(this.dateInit));
    var f2 = moment(new Date(this.dateEnd));
    var h1 = moment(new Date(this.timeInit));
    var h2 = moment(new Date(this.timeEnd));

    var cv: boolean;

    // ------ SI SE SELECCIONA UN CONVOY, SE PROCEDERA A PASAR CREAR EL ARRAY DE LOS VEHICULOS PERTENECIENTES A DICHO CONVOY.
    if (!this.checkboxGroup && !_.isEmpty(this.selectedConvoy) && this.selectedConvoy) {
      cv = true;
      repSubtitle = 'CONVOY: ' + this.selectedConvoy;
      var convoyOrGroupArr = this.vehicles.filter((vehicle: { convoy: any; }) => vehicle.convoy == this.selectedConvoy);
      console.log(repSubtitle, convoyOrGroupArr);
    } else if (this.checkboxGroup && !_.isEmpty(this.selectedGroup) && this.selectedGroup) {
      cv = true;
      repSubtitle = 'GRUPO: ' + this.selectedGroup;
      var convoyOrGroupArr = this.vehicles.filter((vehicle: { grupo: any; }) => vehicle.grupo == this.selectedGroup);
      console.log(repSubtitle, convoyOrGroupArr);
    } else {
      repSubtitle = 'VEHÍCULOS';
      cv = false;
      console.log(this.selectedVehicles);
    }

    var duracionExcesos = (this.selectedDuracion === undefined || this.selectedDuracion === null) ? 0 : this.selectedDuracion.code;
    var toleraciaExcesos = (this.selectedToleracia === undefined || this.selectedToleracia === null) ? 0 : this.selectedToleracia.code;

    var direccionZona = (this.selectedDireccionZona === undefined || this.selectedDireccionZona === null) ? 0 : this.selectedDireccionZona.code;



    var M1 = f1.format("YYYY-MM-DD") + 'T' + h1.format("HH:mm") + ':00-05:00';
    var M2 = f2.format("YYYY-MM-DD") + 'T' + h2.format("HH:mm") + ':00-05:00';
    var M1_t = f1.format("YYYY-MM-DD") + ' ' + h1.format("HH:mm:00");
    var M2_t = f2.format("YYYY-MM-DD") + ' ' + h2.format("HH:mm:00");
    /* var M1 = f1.format("YYYY-MM-DD") + 'T' + this.timeInit + ':00-05:00';
    var M2 = f2.format("YYYY-MM-DD") + 'T' + this.timeEnd + ':00-05:00'; */
    /* 		var M1_t = f1.format("YYYY-MM-DD") + ' ' + this.timeInit + ':00';
    var M2_t = f2.format("YYYY-MM-DD") + ' ' + this.timeEnd + ':00'; */

    var diffTime = moment(new Date(M2)).diff(new Date(M1));
    var duration = moment.duration(diffTime);
    var years = duration.years(),
      days = duration.days(),
      hrs = duration.hours(),
      mins = duration.minutes(),
      secs = duration.seconds();
    var D1 = (days * 24 + hrs) + ":" + (mins > 9 ? mins : "0" + mins) + ":" + (secs > 9 ? secs : "0" + secs);

    //Opciones a incluir en el reporte
    //oG checkboxes
    var oG: any = [];

    //eventos a incluir en el reporte
    //eV checkboxes
    //var eV: any=[];

    //selectedZone[i].id
    //var zonesArr: any=[];

    let reportSelect = _.find(this.reports, (rep: any) => { if (rep.codigo == this.selectedReport) { return true; } else { return false } });
    console.log(reportSelect);

    if (cv) {
      //Convoy o grupo seleccionado
      var vehiculos_imei = []
      for (let index = 0; index < convoyOrGroupArr.length; index++) {
        const element = convoyOrGroupArr[index];
        vehiculos_imei.push({ IMEI: element.IMEI, name: element.name, nameconvoy: element.nameconvoy });
      }
      var param = {
        fecha_actual: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        fecha_desde: M1,
        fecha_hasta: M2, // --N
        vehiculos: JSON.stringify(vehiculos_imei),//JSON.stringify(convoyOrGroupArr),
        grupo: this.selectedConvoy,
        zonas: JSON.stringify(this.selectedZones),
        tags_zonas: JSON.stringify(this.selectedTags),
        url: reportSelect.url, //this.reports[this.selectedReport].url,
        limitVel: !chkDuracion ? this.limitSpeed : false,
        minimDur: chkDuracion ? this.minimDur : false,
        chkOdomV: chkOdomV,
        og: JSON.stringify([this.oG]),
        ev: JSON.stringify([this.eV]),
        ec: JSON.stringify([this.eC]),
        chkStops: this.chkStops,
        chkMovements: this.chkMovements,
        chkTrans1min: this.chkTrans1min,
        chkFatigaSomnolencia: this.chkFatigaSomnolencia,
        chkFatigaDistraccion: this.chkFatigaDistraccion,
        chkFrenada: this.chkFrenada,
        chkAceleracion: this.chkAceleracion,

        duracionExcesos: duracionExcesos,
        toleraciaExcesos: toleraciaExcesos,
        chkRiesgo: this.chkRiesgo,
        direccionZona: direccionZona,
        chkResumenEvXUnidades: this.chkResumenEvXUnidades,
        chkResumenEvXZonas: this.chkResumenEvXZonas,

        limit: true,
        numRep: reportSelect.codigo,//this.reports[this.selectedReport].codigo,//this.reports[this.selectedReport].id,
        isConfirmedFilter: this.optionReportEventConfirmed,
        // add TimeZone INFO
        tzOffset: this.momentServiceLite.tzOffset, // -05:00
        tzCustom: this.momentServiceLite.tzCustom, // - 5 hour
        tzPHP: this.momentServiceLite.tzPHP,       // +5 hours

        optionReportEvaluation: this.optionReportEvaluation,
        tzDefault: this.momentServiceLite.tzDefault
      }
    } else {
      var vehiculos_imei = []
      for (let index = 0; index < this.selectedVehicles.length; index++) {
        const element = this.selectedVehicles[index];
        vehiculos_imei.push({ IMEI: element.IMEI, name: element.name, nameconvoy: element.nameconvoy });
      }
      var param = {
        fecha_actual: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        fecha_desde: M1,
        fecha_hasta: M2, // --N
        //vehiculos: JSON.stringify(vm.selectedVehicle), grupos:vm.selectedConvoy, zonas:JSON.stringify(array_zona),
        vehiculos: JSON.stringify(vehiculos_imei),//JSON.stringify(this.selectedVehicles),
        grupo: this.selectedConvoy,
        zonas: JSON.stringify(this.selectedZones),
        tags_zonas: JSON.stringify(this.selectedTags),
        url: reportSelect.url, //this.reports[this.selectedReport].url,
        limitVel: !chkDuracion ? this.limitSpeed : false,
        minimDur: chkDuracion ? this.minimDur : false,
        chkOdomV: chkOdomV,
        og: JSON.stringify([this.oG]),
        ev: JSON.stringify([this.eV]),
        ec: JSON.stringify([this.eC]),
        chkStops: this.chkStops,
        chkMovements: this.chkMovements,
        chkTrans1min: this.chkTrans1min,
        chkFatigaSomnolencia: this.chkFatigaSomnolencia,
        chkFatigaDistraccion: this.chkFatigaDistraccion,
        chkFrenada: this.chkFrenada,
        chkAceleracion: this.chkAceleracion,

        duracionExcesos: duracionExcesos,
        toleraciaExcesos: toleraciaExcesos,
        chkRiesgo: this.chkRiesgo,
        direccionZona: direccionZona,
        chkResumenEvXUnidades: this.chkResumenEvXUnidades,
        chkResumenEvXZonas: this.chkResumenEvXZonas,

        limit: true,
        numRep: reportSelect.codigo, //this.reports[this.selectedReport].codigo,//this.reports[this.selectedReport].id,
        isConfirmedFilter: this.optionReportEventConfirmed,
        // add TimeZone INFO
        tzOffset: this.momentServiceLite.tzOffset, // -05:00
        tzCustom: this.momentServiceLite.tzCustom, // - 5 hour
        tzPHP: this.momentServiceLite.tzPHP,       // +5 hours

        optionReportEvaluation: this.optionReportEvaluation,
        tzDefault: this.momentServiceLite.tzDefault
      };
    }

    //console.log(param);
    console.log('Proceso iniciado a las: ', moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    console.log(param);

    //CONFIGURACION DE TITULOS
    var repTitle = reportSelect.value;


    if (param.numRep == 'R012' || param.numRep == 'R022') {
      //REPORTE DE DISTRACIÓN Y POSIBLE FATIGA
      if (chkFatigaSomnolencia && chkFatigaDistraccion) {
        repTitle = reportSelect.value;
      } else {
        if (chkFatigaSomnolencia) {
          repTitle = 'REPORTE DE POSIBLE FATIGA';
        }
        if (chkFatigaDistraccion) {
          repTitle = 'REPORTE DE DISTRACIÓN';
        }
      }

    } else if (param.numRep == 'R011') {
      //REPORTE DE FRENADA Y ACELERACIÓN BRUSCA (ECO DRIVE)
      if (chkFrenada && chkAceleracion) {
        repTitle = reportSelect.value;
      } else {
        if (chkFrenada) {
          repTitle = 'REPORTE DE FRENADA BRUSCA';
        }
        if (chkAceleracion) {
          repTitle = 'REPORTE DE ACELERACIÓN BRUSCA';
        }
      }

    } else if (param.numRep == 'R049') {
      if (this.chkResumenEvXUnidades) {
        repTitle = reportSelect.value + " - Por Unidad";
      } else {
        repTitle = reportSelect.value + " - Por Zona";
      }

    } else {
      repTitle = reportSelect.value;
    }

    var str_nombre_eventos = " : ";
    if (param.numRep == 'R037' || param.numRep == 'R038' || param.numRep == 'R040') {
      //REPORTE DE EVENTOS , EVALUACION DE EVENTOS , EVENTOS INTERNOS
      // this.reportService.str_nombre_eventos = " : ";
      str_nombre_eventos = " : ";
      var cantidad_eventos = 0;
      this.events.forEach((event: { name_form: string | number; active: boolean; name_event: string }) => {
        if (event.active) {
          cantidad_eventos++;
          if (str_nombre_eventos == " : ") {
            str_nombre_eventos = str_nombre_eventos + "" + event.name_event.toUpperCase();
          } else {
            str_nombre_eventos = str_nombre_eventos + ", " + event.name_event.toUpperCase();
          }
        }
      });

      if (cantidad_eventos > 3) {
        str_nombre_eventos = "";
      }

    } else {
      str_nombre_eventos = "";
    }


    //if (param.numRep == 'R004' || param.numRep == 'R042') {
    if (param.numRep == 'R004') {
      //REPORTE DE COMBUSTIBLE , COMBUSTIBLE RESUMEN
      // console.log(this.chkCombustibleDetallado+"  -  "+this.chkCombustibleResumen);
      if (this.chkCombustibleResumen) {
        console.log("ESTE REPORTE ES RESUMEN");
        param.numRep = 'R042';
        param.url = "/api/reports/combustible_resumen";
        repTitle = "REPORTE DE COMBUSTIBLE RESUMEN";

      }

    }


    let processReportData = (data: any) => {
      console.log(typeof data);
      console.log(data);
      this.reportService.setDatos(data);
      this.reportService.setParams(param);
      this.setNameDriver(data);
      var report_data = {
        data: data,
        numRep: param.numRep, // codigo
        repSubtitle: repSubtitle,
        chkDateHour: chkDateHour,
        chkFatigaSomnolencia: chkFatigaSomnolencia,
        chkFatigaDistraccion: chkFatigaDistraccion,
        chkFrenada: chkFrenada,
        chkAceleracion: chkAceleracion,

        chkDuracion: chkDuracion,
        chkOdomV: chkOdomV,
        repTitle: repTitle, //reportSelect.value, //this.reports[param.numRep].value,
        period: M1_t + ' - ' + M2_t,
        isVehicleReport: !cv,
        chkTableDropdown: !this.chkSimultaneousTables,
        params: this.reportService.getParams(),

        eC: this.eC,
        chkRiesgo: this.chkRiesgo,
        str_nombre_eventos: str_nombre_eventos,

        operators: this.optionOperators
      }

      const payload: ReportPayload = {
        reportDetails: {
          reportType: param.numRep,
          title: repTitle,
          subtitle: repSubtitle,
          periodRange: M1_t + ' - ' + M2_t,
          isVehicleReport: !cv,
        },
        filters: {
          includeDateHour: chkDateHour,
          includeFatigaSomnolencia: chkFatigaSomnolencia,
          includeFatigaDistraccion: chkFatigaDistraccion,
          includeFrenada: chkFrenada,
          includeAceleracion: chkAceleracion,
          includeDuracion: chkDuracion,
          includeOdomV: chkOdomV,
          includeRiesgo: this.chkRiesgo,
          includeSimultaneousTables: !this.chkSimultaneousTables,
          includeOnlyTable: this.chkOnlyTables,
          includeParadas: this.chkStops,
          includeMovimientos: this.chkMovements,
        },

        eventConfig: {
          selectedEventNames: str_nombre_eventos,
          eventColumns: this.eC,
        },

        generalConfig: {
          columns: this.oG,
        },

        systemParams: this.reportService.getParams(),
        operators: this.optionOperators,
        data: data,
      };

      if (new_tab === undefined || new_tab == true) {
        //Report in the same tab
        this.reportService.showReport.emit(report_data);
        this.reportService.reportGenerated.emit(payload);
        this.isFormFilled = true;
      } else {
        //Report in new tab
        this.spinner.hide("fullScreenSpinner");
        this.reportService.workingOnReport = false;
        this.isFormFilled = true;
        console.log('Se abrió una nueva pestaña');
        localStorage.setItem("report_data", JSON.stringify(report_data));
        localStorage.setItem("report_payload", JSON.stringify(payload));
        let report_tab = null
        if (this.router.url === '/new-reports') {
          report_tab = window.open('/new-reports/result');

        } else {
          report_tab = window.open('/reports/result');
        }
        if (report_tab == null) {
          this.showBlockedTabDialog = true;
        } else {
          this.toastr.success('', 'Reporte generado en una nueva pestaña exitosamente', {
            timeOut: 5000,
          });
        }
      }
    }

    if (this.reportService.simulate) {
      processReportData([[["Listado de Reportes"], []]])
      return;
    }
    console.log('API: ', environment.apiUrl + param.url, param);
    this.http.post(environment.apiUrl + param.url, param).subscribe({
      next: data => {
        processReportData(data)
      },
      error: (err) => {
        console.log(err);
        //console.log('Hubo un error al procesar la solicitud');
        this.spinner.hide("reportSpinner");
        this.errorFlag++;
        const objectError: Record<number, string> = {
          0: 'Solicitud no procesada debido a que contiene mucha información para procesar. Por favor, inténte reduciendo el intervalo de tiempo o las opciones seleccionadas. Si el problema persiste, póngase en contacto con el área de TI.',
          503: 'Solicitud no procesada debido a que contiene mucha información por procesar. Por favor, inténte reduciendo el intervalo de tiempo o las opciones seleccionadas. Si el problema persiste, póngase en contacto con el área de TI.',
          500: 'Ha ocurrido un problema al intentar procesar su solicitud. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.',
        };
        err.status == 503 ? this.waitInit(objectError[err.status]) :
          this.endInit(objectError[err.status]);
        // Swal.fire({
        //   title: 'Error',
        //   text: `Hubo un error al generar el reporte.
        //   Por favor, actualiza la página`,
        //   icon: 'error',
        //   allowOutsideClick: false,
        //   confirmButtonText: 'Actualizar Página',
        // }).then((data) => {
        //   if (data.isConfirmed) {
        //     this.spinner.show('reloadSpinner');
        //     window.location.reload();
        //   }
        // });
      }
    });
  }


  reportar_reporte_programado() {

    this.reportService.eC = JSON.parse(JSON.stringify(this.eC));
    this.reportService.chkRiesgo = this.chkRiesgo;


    this.reportService.workingOnReport = false;
    this.isFormFilled = true;


    var repSubtitle = '';
    var chkDateHour = this.chkDateHour;
    var chkFatigaSomnolencia = this.chkFatigaSomnolencia;
    var chkFatigaDistraccion = this.chkFatigaDistraccion;

    var chkDuracion = this.checkboxDuration;
    var chkOdomV = this.chkOdomVirtual;
    var chkFrenada = this.chkFrenada;
    var chkAceleracion = this.chkAceleracion;


    var f1 = moment(new Date(this.dateInit));
    var f2 = moment(new Date(this.dateEnd));
    var h1 = moment(new Date(this.timeInit));
    var h2 = moment(new Date(this.timeEnd));

    var cv: boolean;

    // ------ SI SE SELECCIONA UN CONVOY, SE PROCEDERA A PASAR CREAR EL ARRAY DE LOS VEHICULOS PERTENECIENTES A DICHO CONVOY.
    if (!this.checkboxGroup && !_.isEmpty(this.selectedConvoy) && this.selectedConvoy) {
      cv = true;
      repSubtitle = 'CONVOY: ' + this.selectedConvoy;
      var convoyOrGroupArr = this.vehicles.filter((vehicle: { convoy: any; }) => vehicle.convoy == this.selectedConvoy);
      console.log(repSubtitle, convoyOrGroupArr);
    } else if (this.checkboxGroup && !_.isEmpty(this.selectedGroup) && this.selectedGroup) {
      cv = true;
      repSubtitle = 'GRUPO: ' + this.selectedGroup;
      var convoyOrGroupArr = this.vehicles.filter((vehicle: { grupo: any; }) => vehicle.grupo == this.selectedGroup);
      console.log(repSubtitle, convoyOrGroupArr);
    } else {
      repSubtitle = 'VEHÍCULOS';
      cv = false;
      console.log(this.selectedVehicles);
    }

    var duracionExcesos = (this.selectedDuracion === undefined || this.selectedDuracion === null) ? 0 : this.selectedDuracion.code;
    var toleraciaExcesos = (this.selectedToleracia === undefined || this.selectedToleracia === null) ? 0 : this.selectedToleracia.code;

    var direccionZona = (this.selectedDireccionZona === undefined || this.selectedDireccionZona === null) ? 0 : this.selectedDireccionZona.code;


    var M1 = f1.format("YYYY-MM-DD") + 'T' + h1.format("HH:mm") + ':00-05:00';
    var M2 = f2.format("YYYY-MM-DD") + 'T' + h2.format("HH:mm") + ':00-05:00';
    var M1_t = f1.format("YYYY-MM-DD") + ' ' + h1.format("HH:mm:00");
    var M2_t = f2.format("YYYY-MM-DD") + ' ' + h2.format("HH:mm:00");
    /* var M1 = f1.format("YYYY-MM-DD") + 'T' + this.timeInit + ':00-05:00';
    var M2 = f2.format("YYYY-MM-DD") + 'T' + this.timeEnd + ':00-05:00'; */
    /* 		var M1_t = f1.format("YYYY-MM-DD") + ' ' + this.timeInit + ':00';
    var M2_t = f2.format("YYYY-MM-DD") + ' ' + this.timeEnd + ':00'; */

    var diffTime = moment(new Date(M2)).diff(new Date(M1));
    var duration = moment.duration(diffTime);
    var years = duration.years(),
      days = duration.days(),
      hrs = duration.hours(),
      mins = duration.minutes(),
      secs = duration.seconds();
    var D1 = (days * 24 + hrs) + ":" + (mins > 9 ? mins : "0" + mins) + ":" + (secs > 9 ? secs : "0" + secs);

    //Opciones a incluir en el reporte
    //oG checkboxes
    var oG: any = [];

    //eventos a incluir en el reporte
    //eV checkboxes
    //var eV: any=[];

    //selectedZone[i].id
    //var zonesArr: any=[];

    let reportSelect = _.find(this.reports, (rep: any) => { if (rep.codigo == this.selectedReport) { return true; } else { return false } });
    console.log(reportSelect);

    if (cv) {
      //Convoy o grupo seleccionado
      var vehiculos_imei = []
      for (let index = 0; index < convoyOrGroupArr.length; index++) {
        const element = convoyOrGroupArr[index];
        vehiculos_imei.push({ IMEI: element.IMEI, name: element.name, nameconvoy: element.nameconvoy });
      }
      var param = {
        fecha_actual: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        fecha_desde: M1,
        fecha_hasta: M2, // --N
        vehiculos: JSON.stringify(vehiculos_imei),//JSON.stringify(convoyOrGroupArr),
        grupo: this.selectedConvoy,
        zonas: JSON.stringify(this.selectedZones),
        tags_zonas: JSON.stringify(this.selectedTags),
        url: reportSelect.url, //this.reports[this.selectedReport].url,
        limitVel: !chkDuracion ? this.limitSpeed : false,
        minimDur: chkDuracion ? this.minimDur : false,
        chkOdomV: chkOdomV,
        og: JSON.stringify([this.oG]),
        ev: JSON.stringify([this.eV]),
        ec: JSON.stringify([this.eC]),
        chkStops: this.chkStops,
        chkMovements: this.chkMovements,
        chkTrans1min: this.chkTrans1min,
        chkFatigaSomnolencia: this.chkFatigaSomnolencia,
        chkFatigaDistraccion: this.chkFatigaDistraccion,
        chkFrenada: this.chkFrenada,
        chkAceleracion: this.chkAceleracion,

        duracionExcesos: duracionExcesos,
        toleraciaExcesos: toleraciaExcesos,
        chkRiesgo: this.chkRiesgo,

        direccionZona: direccionZona,

        limit: true,
        numRep: reportSelect.codigo,//this.reports[this.selectedReport].codigo,//this.reports[this.selectedReport].id,
      }
    } else {
      var vehiculos_imei = []
      for (let index = 0; index < this.selectedVehicles.length; index++) {
        const element = this.selectedVehicles[index];
        vehiculos_imei.push({ IMEI: element.IMEI, name: element.name, nameconvoy: element.nameconvoy });
      }
      var param = {
        fecha_actual: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        fecha_desde: M1,
        fecha_hasta: M2, // --N
        //vehiculos: JSON.stringify(vm.selectedVehicle), grupos:vm.selectedConvoy, zonas:JSON.stringify(array_zona),
        vehiculos: JSON.stringify(vehiculos_imei),//JSON.stringify(this.selectedVehicles),
        grupo: this.selectedConvoy,
        zonas: JSON.stringify(this.selectedZones),
        tags_zonas: JSON.stringify(this.selectedTags),
        url: reportSelect.url, //this.reports[this.selectedReport].url,
        limitVel: !chkDuracion ? this.limitSpeed : false,
        minimDur: chkDuracion ? this.minimDur : false,
        chkOdomV: chkOdomV,
        og: JSON.stringify([this.oG]),
        ev: JSON.stringify([this.eV]),
        ec: JSON.stringify([this.eC]),
        chkStops: this.chkStops,
        chkMovements: this.chkMovements,
        chkTrans1min: this.chkTrans1min,
        chkFatigaSomnolencia: this.chkFatigaSomnolencia,
        chkFatigaDistraccion: this.chkFatigaDistraccion,
        chkFrenada: this.chkFrenada,
        chkAceleracion: this.chkAceleracion,

        duracionExcesos: duracionExcesos,
        toleraciaExcesos: toleraciaExcesos,
        chkRiesgo: this.chkRiesgo,

        direccionZona: direccionZona,

        limit: true,
        numRep: reportSelect.codigo, //this.reports[this.selectedReport].codigo,//this.reports[this.selectedReport].id,
      };
    }

    //console.log(param);
    console.log('Proceso iniciado a las: ', moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    console.log(param);


    //CONFIGURACION DE TITULOS
    var repTitle = reportSelect.value;


    if (param.numRep == 'R012' || param.numRep == 'R022') {
      //REPORTE DE DISTRACIÓN Y POSIBLE FATIGA
      if (chkFatigaSomnolencia && chkFatigaDistraccion) {
        repTitle = reportSelect.value;
      } else {
        if (chkFatigaSomnolencia) {
          repTitle = 'REPORTE DE POSIBLE FATIGA';
        }
        if (chkFatigaDistraccion) {
          repTitle = 'REPORTE DE DISTRACIÓN';
        }
      }

    } else if (param.numRep == 'R011') {
      //REPORTE DE FRENADA Y ACELERACIÓN BRUSCA (ECO DRIVE)
      if (chkFrenada && chkAceleracion) {
        repTitle = reportSelect.value;
      } else {
        if (chkFrenada) {
          repTitle = 'REPORTE DE FRENADA BRUSCA';
        }
        if (chkAceleracion) {
          repTitle = 'REPORTE DE ACELERACIÓN BRUSCA';
        }
      }

    } else {
      repTitle = reportSelect.value;
    }

    console.log('API: ', environment.apiUrl + param.url, param);


    this.reportService.paramsReportesProgramados = param;
    this.reportService.modalReportesProgramadosActive = true;


  }





  setNameDriver(data: any) {
    const reporstWithDriver = ['R037', 'R038', 'R039', 'R040', 'R020', 'R041', 'R044', 'R047', 'R055', 'R056'];

    //PARA REPORTES R008 - POSICION
    if (this.selectedReport == 'R008') {
      //PARA REPORTES QUE SOLO TIENEN UN ARRAY
      for (let index of data) {
        // console.log(index);
        if (index.conductor == 0) {
          index.conductor = 'No Especificado';
        } else {
          if (index.conductor != '-' && index.conductor) {
            //const nameDriver = this.driversService.getDriverById(index.conductor)
            const nameDriver = this.getDriverById(index.conductor)
            if (nameDriver != 'No Especificado') {
              index.conductor = nameDriver;
            } else {
              index.conductor = '-';
            }
          }
        }
        if (index.idConductor != '-' && index.idConductor) { //OBTIENE LA IBUTTON COMPLETA
          //index.idConductor = this.driversService.getIbutton(index.idConductor);
          index.idConductor = this.getIbutton(index.idConductor);
        }
      }
    } else if (this.selectedReport == "R053") { // showVehiclesCipia report
      //PARA REPORTES CHECKLIST
      for (let index of data.data[0]) {
        // console.log(index);
        index.conductorEvent = '-';
        if (index.params.driverId && index.params.driverId != 0 && index.conductor != '-') {
          //const nameDriver = this.driversService.getDriverById(index.conductor)
          const nameDriver = this.getDriverByCipia(index.params.driverId)
          if (nameDriver != 'No Especificado') {
            index.conductorEvent = nameDriver;
          } else {
            index.conductorEvent = '-';
          }
        }
      }

    } else if (reporstWithDriver.includes(this.selectedReport)) {
      //PARA REPORTES QUE SOLO TIENEN DOS ARRAY
      //PARA REPORTES QUE TIENEN CONDUCTOR Y IDCONDUCTOR
      for (let index of data) {
        for (let subindex of index[1]) {
          // console.log(subindex);
          if (subindex.conductor == 0) {
            subindex.conductor = '-';
          } else {
            //const nameDriver = this.driversService.getDriverById(subindex.conductor)
            const nameDriver = this.getDriverById(subindex.conductor)
            if (nameDriver == 'No Especificado') {
              subindex.conductor = '-';
            } else {
              subindex.conductor = nameDriver;
            }
          }
          if (subindex.idConductor != '-' && subindex.idConductor) { //OBTIENE LA IBUTTON COMPLETA
            //subindex.idConductor = this.driversService.getIbutton(subindex.idConductor);
            subindex.idConductor = this.getIbutton(subindex.idConductor);
            if (subindex.conductor == '-') {
              subindex.conductor = 'No Especificado';
            }
          } else {
            subindex.idConductor = '-';
          }
          // console.log('SUBINDEX IDCONDUCTOR',subindex.idConductor);
        }
      }
    } else {
      //NO MUESTRA CONDUCTOR...
    }
  }

  changedReport() {
    console.log(this.selectedReport);
    console.log(typeof this.selectedReport);

    //this.titleService.setTitle(this.reports[this.selectedReport].value);
    this.showSubLimitTime = true;
    // this.isReportSupported = true;
    this.showCard = false; //Div que contiene [ showExcVelOpt - showMovStop - showZones - showCheckboxs ]
    this.showExcVelOpt = false; //Limite de velocidad
    this.showOdomOpt = false; // Combustible
    this.showZones = false; // Seleccionador de geocercas
    this.showTagGeocercaOrGeocerca = false;
    this.showTagsZones = false; //Tags de geocercas
    this.showCheckboxs = false;// Opciones reporte general
    this.showCheckboxsCipia = false;// Opciones reporte general CIPIA
    this.showTipoExcesoVelocidad = false; //Opciones excesos de velocidad duracion tolerancia
    this.showOperatividadEquipos = false; // Opciones reporte de operatividad de equipos
    this.showExcesoNivelDuracion = false; //Opciones de exceso velocidad con nivel y duracion
    this.showParadasMovimientos = false; //Opciones de exceso velocidad con nivel y duracion
    this.showDireccionGeocerca = false; //Opciones direccion geocerca (SUBIDA , BAJADA)
    this.showMovStop = false; //Ver Paradas y Movimiento
    this.showDivHorizontal = false; // Nombre de cabecera del reporte
    this.showLimitTime = false; //Configuracion de rango de tiempo -- true la mayoria
    this.showEvents = false; //Configuracion
    this.showOnlyEvents = false; //Configuracion
    this.showEventsCipia = false; //Configuracion
    this.showAtencionEventsCipia = false;
    this.showTrans1min = false; //Configuracion de duracion de parada >1min
    this.showFatigaOp = false; //Configuracion de opcion de fatiga 2
    this.showBrakeAccel = false; //Configuración Aceleracion y frenada
    this.showFatigaDistraccion = false; //Configuracion Distraccion y posible fatiga
    this.showCombustibleOpt = false; //Configuracion de reporte de combustible
    this.showMonitoreoResumenXDia = false; //Configuracion de reporte Monitoreo Cantidad de Eventos por unidad.

    /* this.showTimeLlegada = false;
    this.showTimePeriodoDia = false; */

    let aux_convoy = this.vehicles.filter((vehicle: { idconvoy: any; }) => vehicle.idconvoy == this.selectedConvoy);
    let aux_group = this.vehicles.filter((vehicle: { idgrupo: any; }) => vehicle.idgrupo == this.selectedGroup);

    var permissionList = JSON.parse(localStorage.getItem('PermissionList')!);
    var checkPermission = permissionList.includes('reports_simultaneous_' + this.selectedReport);

    this.showChkSimultaneousTables =
      (this.selectedVehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1) ||
      (aux_convoy.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1) ||
      (aux_group.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1);

    this.showChkSimultaneousTables = this.showChkSimultaneousTables && checkPermission;

    // this.showChkSimultaneousTables = this.selectedVehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1

    this.showVehiclesCipia = false;
    this.selectedVehicles = this.chkAllVehicles ? this.vehicles : this.selectedVehicles;
    switch (this.selectedReport) {
      case 'R053':
      case 'R054':
        if (this.selectedReport == 'R053') {
          this.showLimitTime = true; // checklist
        }
        this.selectedVehicles = this.selectedVehicles.filter((vehicle: any) => {
          return vehicle.IMEI?.startsWith('E');
        });
        this.showVehiclesCipia = true;
        break;
      case 'R001': // 0 - R001	REPORTE DE PARADAS Y MOVIMIENTOS
        this.showMovStop = true;
        this.showLimitTime = true;
        break;
      case 'R002': // 1 - R002	REPORTE DE EXCESOS DE VELOCIDAD
        this.showExcVelOpt = true;
        this.showLimitTime = true;
        break;
      case 'R003': // 2 - R003	REPORTE DE ENTRADA Y SALIDA
        this.showZones = true;
        this.showTagGeocercaOrGeocerca = true;
        this.showTagsZones = false;
        this.showLimitTime = true;
        break;
      case 'R004': // 3 - R004	REPORTE DE COMBUSTIBLE
        this.showLimitTime = true;
        this.showOdomOpt = true;
        this.showCombustibleOpt = true;
        break;
      case 'R005': // 4 - R005	REPORTE DE EXCESOS EN ZONA
        this.showLimitTime = true;
        break;
      case 'R006': // 5 - R006	REPORTE GENERAL
        this.showLimitTime = true;
        this.showCheckboxs = true;
        break;
      case 'R007': // 6 - R007	REPORTE DE EVENTOS
        this.showLimitTime = true;
        this.showEvents = true;
        break;
      case 'R008': // 7 - R008	REPORTE DE POSICIÓN
        break;
      case 'R020':  // 19 -R020	REPORTE GERENCIAL (Cuenta cruzdelsur)
      case 'R026':  //    -R026 NEW 2
      case 'R027':  //    -
      case 'R028':  //    -
      case 'R029':  //    -
      case 'R030':  //    -
      case 'R031':  //    -
      case 'R032':  //    -
        this.showLimitTime = true;
        break;
      case 'R033':  //    -
        this.showZones = true;
        break;
      case 'R034':  //    -
      case 'R035':  //    -
        //this.showZones = true;
        break;
      case 'R036':  //   - R036	REPORTE GENERAL CIPIA
        this.showLimitTime = true;
        this.showCheckboxsCipia = true;
        // this.showCheckboxs = true;
        break;
      case 'R037':  //   - R037	REPORTE DE EVENTOS
        this.showLimitTime = true;
        this.showEventsCipia = true;
        // this.showEvents = true;

        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: true,
          Codigo: true,
          Placa: true,
          TipoUnidad: true,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: true,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: true,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: false,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,
        }

        break;
      case 'R038':  //   - R038	REPORTE DE ATENCIÓN DE EVENTOS
        this.showLimitTime = true;
        this.showAtencionEventsCipia = true;
        // this.showEvents = true;
        // this.updateCheckDefaultEvents();
        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: true,
          NombreEvento: true,
          Evento: true,
          Codigo: true,
          Placa: true,
          TipoUnidad: true,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: true,
          CriterioEvaluacion: true,
          Observacion: true,
          Validacion: true,

          VelMobileye: false,
          VelGPS: true,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: true,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: false,
          ComRadial: true,
          ConMasDetalle: false,
          OperadorMonitoreo: true,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,
        }

        break;
      case 'R039': //  - R039	REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)
        this.showLimitTime = true;
        break;
      case 'R040':  //   - R040	REPORTE DE EVENTOS INTERNO
        this.showLimitTime = true;
        this.showEventsCipia = true;
        // this.showEvents = true;

        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: true,
          Codigo: true,
          Placa: true,
          TipoUnidad: true,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: true,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: true,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: false,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,
          
        }

        break;
      case 'R041':
        this.showLimitTime = true;
        this.showTipoExcesoVelocidad = true;

        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: false,
          Codigo: true,
          Placa: true,
          TipoUnidad: false,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: false,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: false,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: true,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }

        break;
      case 'R042': //  - R042	REPORTE DE COMBUSTIBLE RESUMEN
        this.showLimitTime = true;
        break;
      case 'R043': // - R043 REPORTE DE ESTADO DE TRANSMISION
        this.showLimitTime = true;
        break;
      case 'R044': // R044 REPORTE DE EXCESO DE VELOCIDAD CON DIRECCION
        this.showLimitTime = true;
        this.showTipoExcesoVelocidad = true;

        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: false,
          Codigo: true,
          Placa: true,
          TipoUnidad: false,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: false,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: false,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: true,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }

        break;
        break;
      case 'R045': // - R045 REPORTE DE BOLIVIA
        this.showLimitTime = true;
        break;
      case 'R046': // - R046
        this.showLimitTime = true;

        this.eV = {
          GPSwithTransmission: true,
          GPSwithoutTransmission: true,
        }

        this.eC = {
          Fecha: false,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: false,
          Codigo: false,
          Placa: false,
          TipoUnidad: false,
          IdConductor: false,
          Conductor: false,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: false,
          VelCAN: false,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: true,
          Ubicacion: true,
          Referencia: true,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: false,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }

        // ev: JSON.stringify([this.eV]),
        break;
      case 'R047':
        this.showLimitTime = true;
        this.showTipoExcesoVelocidad = true;

        this.eC = {
          Fecha: true,
          Hora: false,
          FechaServidor: false,
          NombreEvento: true,
          Evento: false,
          Codigo: true,
          Placa: true,
          TipoUnidad: false,
          IdConductor: false,
          Conductor: true,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: false,
          VelCAN: true,
          VelECO: false,
          VelGPSspeed: false,

          Zona: true,
          PuntoCercano: false,
          Ubicacion: true,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: true,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: false,
          VelMaxima: false,
          Niveles: false,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }

        break;

      case 'R048':
        this.showLimitTime = true;
        break;

      case 'R049':
        this.showLimitTime = true;
        //this.showAtencionEventsCipia = true;
        this.showMonitoreoResumenXDia = true;
        this.showOnlyEvents = true;
        break;

      case 'R050':
        this.showOdomOpt = true;
        this.showLimitTime = true;
        break;

      case 'R051':
        this.showOperatividadEquipos = true;

        this.eC = {
          Fecha: true,
          Hora: true,
          FechaServidor: false,
          NombreEvento: false,
          Evento: false,
          Codigo: true,
          Placa: true,
          TipoUnidad: false,
          IdConductor: false,
          Conductor: false,

          FechaEvaluacion: false,
          CriterioEvaluacion: false,
          Observacion: false,
          Validacion: false,

          VelMobileye: false,
          VelGPS: false,
          VelCAN: false,
          VelECO: false,
          VelGPSspeed: false,

          Zona: false,
          PuntoCercano: false,
          Ubicacion: false,
          Referencia: false,
          EnlaceArchivo: false,
          Parametros: false,
          Satelite: false,
          ComRadial: false,
          ConMasDetalle: false,
          OperadorMonitoreo: false,  // R. Atención de Eventos
          humedad: false,
          temperatura: false,

          estadoGPS: false,
          estadoCipia: false,
          campoFatiga: false,
          campoCaredrive: false,
          campoCAN: false,
          campoADAS: false,
          campoAlcotester: false,


          campoGerencia: true,
          campoRuta: true,
          campoDuracion: true,
          VelMaxima: true,
          Niveles: true,
          campoFalta: true,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }
        break;

      case 'R055':
        this.showLimitTime = true;
        this.showTipoExcesoVelocidad = true;
        this.showDireccionGeocerca = true;
        break;

      case 'R056':
        this.showLimitTime = true;
        this.showExcesoNivelDuracion = true;
        //this.showTipoExcesoVelocidad = true;
        //this.showDireccionGeocerca = true;

        //this.eV.platformExcesoVelocidadDuracionDireccion = true;

        this.eV = {
          platformExcesoVelocidadDuracionDireccion: true,
        }
        this.eC = {
          Fecha: true,
          Hora: true,
          FechaServidor: true,
          NombreEvento: true,
          Evento: true,
          Codigo: true,
          Placa: true,
          TipoUnidad: true,
          IdConductor: true,
          Conductor: true,

          FechaEvaluacion: true,
          CriterioEvaluacion: true,
          Observacion: true,
          Validacion: true,

          VelMobileye: true,
          VelGPS: true,
          VelCAN: true,
          VelECO: true,
          VelGPSspeed: true,

          Zona: true,
          PuntoCercano: true,
          Ubicacion: true,
          Referencia: true,
          EnlaceArchivo: true,
          Parametros: true,
          Satelite: true,
          ComRadial: true,
          ConMasDetalle: true,
          OperadorMonitoreo: true,  // R. Atención de Eventos
          humedad: true,
          temperatura: true,

          estadoGPS: true,
          estadoCipia: true,
          campoFatiga: true,
          campoCaredrive: true,
          campoCAN: true,
          campoADAS: true,
          campoAlcotester: true,

          campoGerencia: false,
          campoRuta: false,
          campoDuracion: true,
          VelMaxima: true,
          Niveles: true,
          campoFalta: false,
          newDriver: false,

          //campoDuracion: false,
          campoDistancia: false,
          VelMaxGPS: false,
          VelMaxCAN: false,
          //Zona: false,
          //PuntoCercano: false,
          VelPromGPS: false,
          VelPromCAN: false,
          //Ubicacion: false,
          //Referencia: false,

        }
        break;
      case 'R057':
      case 'R059':
        this.showMovStop = true;
        this.showLimitTime = true;
        this.showParadasMovimientos = true;
        break;
      case 'R058':
        this.showLimitTime = true;
        break;
      default: break;
    }
    /*  console.log(Object.keys(this.reports[this.selectedReport]).length === 0);
    console.log(_.isEmpty(this.reports[this.selectedReport])); */
    console.log(_.isEmpty(this.selectedReport));
    console.log(this.selectedReport);
    console.log(typeof this.selectedReport);
    console.log("Selected report", this.selectedReport);
    // console.log("Grupo", this.checkboxGroup && !_.isEmpty(this.selectedGroup) && this.selectedGroup);
    // console.log("Convoy", !this.checkboxGroup && !_.isEmpty(this.selectedConvoy) && this.selectedConvoy);
    console.log("Vehiculos en el Convoy", this.vehicles.filter((vehicle: { nameconvoy: any; }) => vehicle.nameconvoy == this.selectedConvoy));
    console.log("Selected Vehicles", this.selectedVehicles);

    this.isReportSupported = this.reportService.isReportSupported(this.selectedReport)
    this.isReportWithSummary = this.reportService.isReportWithSummary(this.selectedReport)
    if (this.isReportWithSummary) {
      this.chkOnlyTables = false;
    }
    let reportCategoryBase = this.reportService.isReporBasic(this.selectedReport)
    if (reportCategoryBase) {
      this.isReportWithSummary = true;
      this.chkOnlyTables = false;
    }
    if (this.selectedReport == 'R049') { // reporte eventos por unidad
      this.isReportWithSummary = true;
      this.chkOnlyTables = false;
    }
  }

  dismissBlockedTabDialog() {
    this.showBlockedTabDialog = false;
    this.toastr.error('', 'No se pudo reportar en nueva pestaña', {
      timeOut: 5000,
    });
  }

  onSelectedVehiclesChange() {
    // this.selectedConvoy = {};
    // this.selectedGroup = {};
    console.log(this.selectedVehicles)
    this.chkAllVehicles = this.selectedVehicles.length == this.vehicles.length;
    this.showChkSimultaneousTables = this.selectedVehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;
  }

  onSelectedConvoyChange() {
    this.selectedVehicles = [];
    this.selectedGroup = {};
    this.chkAllVehicles = false;

    let aux_vehicles = this.vehicles.filter((vehicle: { convoy: any; }) => vehicle.convoy == this.selectedConvoy);
    this.showChkSimultaneousTables = aux_vehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;
  }

  onSelectedGroupChange() {
    this.selectedVehicles = [];
    this.selectedConvoy = {};
    this.chkAllVehicles = false;

    let aux_vehicles = this.vehicles.filter((vehicle: { grupo: any; }) => vehicle.grupo == this.selectedGroup);
    this.showChkSimultaneousTables = aux_vehicles.length > 1 && this.singleTableReportIDs.indexOf(this.selectedReport) == -1;
  }

  onSelectedGeofenceschange() {
    this.chkAllZones = this.zones.length == this.selectedZones.length;
  }

  onSelectedTagschange() {
    this.chkAllTags = this.listTags.length == this.selectedTags.length;
  }


  onChkDateHourChange() {
    console.log(this.chkDateHour);
    this.onTimeChange();
  }

  onTimeChange() {
    let date_init = parseInt(moment(this.dateInit).format('YYYYMMDD'));
    let date_end = parseInt(moment(this.dateEnd).format('YYYYMMDD'));
    let time_init = parseInt(moment(this.timeInit).format('HHmm'));
    let time_end = parseInt(moment(this.timeEnd).format('HHmm'));
    console.log('date init', parseInt(moment(this.dateInit).format('YYYYMMDD')));
    console.log('date end', this.dateEnd);
    console.log('time init', moment(new Date(this.timeInit)).format("HH:mm"));
    console.log('time end', this.timeEnd);
    if (this.dateInit != null && this.dateEnd != null && this.timeInit != null && this.timeEnd != null) {
      console.log(date_init, date_end);
      console.log(time_init, time_end);
      if (date_init < date_end) {
        this.areHoursValid = true;
        this.areDatesValid = true;
      } else if (date_init == date_end) {
        this.areHoursValid = time_init <= time_end;
        this.areDatesValid = this.areHoursValid;
      } else {
        this.areHoursValid = false;
        this.areDatesValid = false;
      }
    } else {
      this.areHoursValid = true;
      this.areDatesValid = false;
    }
    console.log(this.areHoursValid);
    console.log(this.areDatesValid);
  }

  onChkAllEvents() {
    this.events.forEach((event: { name_form: any; active: boolean; }) => {
      event.active = this.eV.OtroTodos;
      this.eV[event.name_form] = event.active;
    });

    this.eventsTypes.forEach((type: { selectAll: boolean; }) => {
      type.selectAll = this.eV.OtroTodos;
    });
    console.log(this.eV);
  }

  onChangeChkEvents() {
    this.events.forEach((event: { name_form: string | number; active: boolean; }) => {
      this.eV[event.name_form] = event.active;
      if (this.selectedReport == "R056") {
        //event.active = true;
        this.eV['platformExcesoVelocidadDuracionDireccion'] = true;
      }
    });
    // Verificar si al menos un event.active es false
    const alMenosUnFalse = this.events.some((event: { active: boolean; }) => event.active === false);
    // Actualizar this.ev.OtroTodos
    this.eV.OtroTodos = !alMenosUnFalse;
    console.log(this.eV, this.eC, this.oG);
  }

  validateForm() {
    var is_vehicle_selected = (this.selectedVehicles.length != 0 || JSON.stringify(this.selectedOperation) != '{}' || JSON.stringify(this.selectedConvoy) != '{}' || JSON.stringify(this.selectedGroup) != '{}');
    var is_zone_selected = this.selectedZones.length != 0;
    var is_tag_selected = this.selectedTags.length != 0;

    this.isFormFilled =
      (JSON.stringify(this.selectedReport) != '{}') &&
      this.areDatesValid &&
      (

        (this.selectedReport == 'R001' && is_vehicle_selected && (this.chkStops || this.chkMovements))
        ||
        (this.selectedReport == 'R002' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R003' && is_vehicle_selected && (is_zone_selected || is_tag_selected))
        ||
        (this.selectedReport == 'R004' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R005' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R006' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R007' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R008' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R020' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R026' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R027' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R028' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R029' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R030' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R031' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R032' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R033')
        ||
        (this.selectedReport == 'R034')
        ||
        (this.selectedReport == 'R035')
        ||
        (this.selectedReport == 'R036' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R037' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R038' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R039' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R040' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R041' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R042' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R043' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R044' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R045' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R046' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R047' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R048' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R049' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R050' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R051' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R053' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R054' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R055' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R056' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R057' && is_vehicle_selected && (this.chkStops || this.chkMovements))
        ||
        (this.selectedReport == 'R058' && is_vehicle_selected)
        ||
        (this.selectedReport == 'R059' && is_vehicle_selected)

      );
  }

  resetAllFields() {

    this.chkOdomVirtual = false;
    this.chkStops = false;
    this.chkMovements = false;
    this.chkFrenada = false;
    this.chkAceleracion = false;

    //0. Paradas y Movimientos
    this.chkStops = true;
    this.chkMovements = true;

    //1. Exceso de velocidad
    this.checkboxDuration = false;
    this.minimDur = 15;
    this.limitSpeed = 90;

    //2. Entrada y Salida
    //Se solicitó que las geocercas no se reseteen.
    /* this.selectedZones = [];
    this.chkAllZones = false; */

    //3. Combustible
    this.chkOdomVirtual = false;
    this.odometroVirtual = 0;

    //4. Frenada y Acel Brusca
    this.chkFrenada = true;
    this.chkAceleracion = true;

    //5. General
    this.oG = {
      DUOT2state: false, // --- NEW2
      RPMAlta: false,
      RxM: false,
      aBrusca: false,
      alcoholemia: false,
      altitud: false,
      angulo: false,
      cMotor: false,
      cRestante: false, // --- NEW
      fBrusca: false,
      fExBrusca: false,
      fServidor: false,   // --- NEW
      fatiga: false,
      cNivel: false,  //  NEW
      odometro: false,
      onOff: false,
      pCercano: false,
      parametros: false,  // --- NEW
      recFacial: false,
      referencia: false,
      ubicacion: false,
      velCAN: false,
      velECO: false,
      velGPS: false,
      velGPS_speed: false,
      velMobileye_ME460: false,
      errorMobileye_ME427: false,
      //NEW 24-01
      alimentGps: false,
      nivelBateria: false,
      nivelCobertura: false,
      temperaturaGps: false,
      satelite: false,
      bleTemperature: false,
      eyeTemperature: false,
      eyeHumedad: false,
      bleHumedad: false,
      geocerca: false,
      direccionGeocerca: false,
      voltageLevel: false
    };


    //6. Eventos
    this.events.forEach((event: { name_form: any; active: boolean; }) => {
      event.active = false;
      this.eV[event.name_form] = false;
    });
    //Reporte 10
    this.chkFatigaSomnolencia = true;
    this.chkFatigaDistraccion = true;


    this.eventsTypes.forEach((evType: any) => {
      evType.selectAll = false;
    });
  }

  logDropState() {
    console.log(this.chkSimultaneousTables);
  }

  changeOptionsEvaluations() {
    console.log('OptionsEvaluation : ', this.optionReportEvaluation);
    const key = String(this.optionReportEvaluation) as 'true' | 'false' | 'null';
    this.optionReportEvaluationLabel = this.optionsLabelMap[key];

    if (this.optionReportEventEvaluation == 'false') {
      this.optionReportEvaluation = false;
    } else if (this.optionReportEventEvaluation == 'true') {
      this.optionReportEvaluation = true;
    } else {
      this.optionReportEvaluation = null;
    }
  }


  // MomentService
  private momentServiceLite = {
    tzDefault: 'America/Lima',
    tzCustom: '- 5 hour',
    tzOffset: '-05:00',
    tzPHP: '+5 hours'
  };

  setTimeZoneDefault() {
    const timezone = moment.tz.guess(); // Devuelve la zona horaria del sistema
    const fecha = moment().tz(timezone);
    const offset = fecha.format('Z');

    const offSetDatabase = this.customUtcDatabase();
    const offSetPHP = this.customUtcPhp();

    this.momentServiceLite.tzDefault = timezone;
    this.momentServiceLite.tzOffset = offset;
    this.momentServiceLite.tzCustom = offSetDatabase;
    this.momentServiceLite.tzPHP = offSetPHP;

    console.log(`MomentService tzDefault : ${timezone}`);
    console.log(`MomentService tzOffset  : ${offset}`);
    console.log(`MomentService tzCustom  : ${offSetDatabase}`);
    console.log(`MomentService tzPHP     : ${offSetPHP}`);
  }
  customUtcDatabase() {
    const utcOffset = this.getUTCOffset(this.get('YYYY/MM/DD HH:mm:ss') as string);
    const formattedOffset = `${utcOffset < 0 ? '-' : '+'} ${Math.abs(utcOffset)} hour`;
    return formattedOffset;
  }

  customUtcPhp() {
    const utcOffset = this.getUTCOffset(this.get('YYYY/MM/DD HH:mm:ss') as string);
    const formattedOffset = `${utcOffset < 0 ? '+' : '-'}${Math.abs(utcOffset)} hours`;
    return formattedOffset;
  }
  get(toFormat?: string) {
    if (toFormat) {
      return this.setFormat(moment(new Date()), toFormat);
    }
    return moment(new Date());
  }

  formatDefault: string = 'YYYY/MM/DD HH:mm:ss';
  private toLocal(utcDateTime: string, toFormat?: boolean) {
    const utcMoment = moment.utc(utcDateTime, this.formatDefault);
    if (toFormat) {
      return this.setFormat(utcMoment.local());
    } else {
      return utcMoment.local();
    }
  }
  setFormat(date: moment.Moment, newFormat?: string): string {
    if (newFormat) {
      return date.format(newFormat);
    }
    return date.format(this.formatDefault);
  }
  getUTCOffset(date: string): number {
    return moment(date, this.formatDefault).utcOffset() / 60;
  }

  private eventServiceLite = {
    getEventsForUser: () => {
      return this.http.get<any>(`${environment.apiUrl}/api/getPermissEvents`);
    }
  }

  private drivers: Driver[] = []
  private availableIbuttons: Ibutton[] = [];
  private async getAllDrivers() {
    await this.http.get<ResponseInterface>(`${environment.apiUrl}/api/driverDataAll`).toPromise()
      .then(response => {
        console.log("------------CONDUCTORES");
        console.log(response.data);

        this.drivers = response.data[0];
        // this.ibuttons = response.data[1];
        // this.icipias = response.data[2];
        // this.idUser = response.data[3];
      });
  }
  private getDriverById(id: number) {
    const driver = this.drivers.find(driver => driver.id == id);
    if (driver) {
      return driver.nombre_conductor;
    } else {
      return 'No Especificado';
    }
  }

  private getDriverByCipia(idCipia: string) {
    const driver = this.drivers.find(driver => driver.nro_cipia === idCipia);
    if (driver) {
      return driver.nombre_conductor;
    } else { }
    return 'No Especificado';
  }

  private async getIbuttonAll() {
    await this.http.get<ResponseInterface>(`${environment.apiUrl}/api/ibuttonsAll`).toPromise()
      .then(response => {
        this.availableIbuttons = response.data;
      });
  }
  private getIbutton(idDriver: string): string {
    const ibutton = this.availableIbuttons.find((ibutton: Ibutton) =>
      ibutton.var_llave!.includes(idDriver!)
    );
    if (ibutton) {
      return ibutton.var_llave!;
    } else {
      return idDriver;
    }
  }

  private userData: any = {};
  private getUserData(): Promise<void> {
    return this.http
      .post<{ data: any }>(environment.apiUrl + '/api/userData', {})
      .toPromise()
      .then(response => {
        this.userData = response.data;
      })
      .catch(error => {
        console.log('No se pudo obtener datos del usuario', error);
        return Promise.reject(error);
      });
  }

  private loadVehiclesCipia() {
    this.vehiclesCipia = this.vehicles.filter((vehicle: any) => {
      return vehicle.IMEI?.startsWith('E');
    });
  }

  private statusDataVehicle = false;
  private async initVehicle() {
    this.getVehicles().subscribe(async (vehicles) => {
      const vehiclesListService = this.dataFormatVehicle(vehicles)
      this.statusDataVehicle = true;
      if (vehiclesListService) {
        this.vehicles = await this.reducedInfoVehicles(vehiclesListService);
        let imei = this.route.snapshot.queryParamMap.get('imei') || null;
        if (imei) {
          let vehicleFind = this.vehicles.find((v: any) => v.IMEI == imei)
          this.selectedVehicles = [vehicleFind]
          this.onSelectedVehiclesChange(); this.validateForm();
          if (this.selectedReport) {
            this.reportService.simulate = false;
            this.reportar()
          }
        }
        this.loadVehiclesCipia();
        this.ListVehicles = this.vehicles;
        this.areVehiclesLoaded = true;
      } else {
        this.errorFlag++;
      }
      this.endInit('Ha ocurrido un problema al intentar obtener la información de los vehículos. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.');
    })
  }

  public getVehicles(): Observable<any> {
    const URL = environment.apiUrl + '/api/tracker'
    return this.http.get(URL);
  }

  private dataFormatVehicle(vehicles: any): any {
    const items = vehicles;
    const userConfigId = 0; //configuracion de usuario

    for (const i in items) {
      items[i] = this.formatVehicle(items[i]);
      items[i].user_id = userConfigId;
      items[i].dt_tracker = this.toLocal(
        items[i].dt_tracker,
        true
      );
      items[i].id_conductor = items[i].driver_id;
      items[i].namedriver =
        items[i].driver_id != 0
          ? this.getDriverById(items[i].driver_id)
          : 'No encontrado';
      // items[i] = this.addSelect(items[i]);
      // items[i] = this.addTank(items[i]);
      // items[i].parametrosGet = this.addParams(items[i].parametros);
      // items[i].tipoGps = this.addTypeGps(items[i].parametros);
      // items[i]=this.addSignal(items[i],today);
      // items[i] = this.addVel(items[i]);
      // items[i] = this.addPointColor(items[i]);
    }
    return items;
  }
  public formatVehicle(vehicle: any): any {
    if (vehicle.speed > 6) {
      vehicle.paradaDesde = false;
    }
    vehicle = this.addSelect(vehicle);
    vehicle = this.addTank(vehicle);
    vehicle.parametrosGet = this.addParams(vehicle.parametros);
    vehicle.tipoGps = this.addTypeGps(vehicle.parametros);
    vehicle = this.addSignal(vehicle);
    vehicle = this.addVel(vehicle);
    vehicle = this.addPointColor(vehicle);
    return vehicle;
  }

  private addPointColor(vehicle: any) {
    if (vehicle.point_color == undefined) {
      vehicle.point_color = 100; //grey
    }
    if (vehicle.user_id != 445) {
      vehicle = this.addPointColorUser(vehicle);
    } else {
      vehicle = this.addPointColorUser445(vehicle);
    }
    return vehicle;
  }

  private addPointColorUser(vehicle: any) {
    if (
      vehicle.v_sat == 0 ||
      (vehicle.v_vel > 3 && (vehicle.v_on == 0 || vehicle.v_ac < 5))
    ) {
      vehicle.point_color = 60; //ROJO - UNIDAD CON ERROR DE GPS
    } else if (vehicle.v_on == 0) {
      // DI4 o CUSTOM IGN = 0
      if (vehicle.c_01 >= 7200) {
        //mayor a 2 horas //==>4
        vehicle.point_color = 40; //NEGRO - UNIDAD SIN TRANSMISION
      } else if (vehicle.v_vel <= 3) {
        //menor a 2 horas //==>3
        vehicle.point_color = 30; //MORADO - UNIDAD DETENIDA SIN IGNICION
      }
    } else {
      if (vehicle.v_vel > 3 && vehicle.v_on == 1) {
        if (vehicle.c_01 > 300) {
          //mayor a 5 minutos //==>5
          vehicle.point_color = 50; //NARANJA - UNIDAD SIN COBERTURA
        } else {
          //menor a 5 minutos //==>1
          vehicle.point_color = 10; //VERDE - UNIDAD EN MOVIMIENTO
          if (vehicle.m5 > 0) {
            clearTimeout(vehicle.m5);
            vehicle.m5 = 0;
          }
          vehicle.m5 = setTimeout(() => {
            // //console.log("MAS DE 5 MINUTOS SIN TRANSMISION, EN MOVIMIENTO , ZONA DE NO COBERTURA: " + item.name);
            vehicle.c_02 = moment(new Date()).diff(
              moment(new Date(vehicle.dt_tracker.replace(/-/g, '/'))),
              'seconds'
            );
            if (vehicle.v_vel > 3 && vehicle.v_on == 1 && vehicle.c_02 >= 300) {
              //mayor a 5 minutos //==>5
              vehicle.point_color = 50; //NARANJA - UNIDAD SIN COBERTURA
              vehicle.m5 = 0;
            }
          }, (300 - vehicle.c_01) * 1000);
        }
      } else if (vehicle.v_vel <= 3 && vehicle.v_on == 1) {
        // img_url = "/images/objects/arrow-2-blue.svg"; //==>2 Parada (Prendida)
        vehicle.point_color = 20; //AZUL - UNIDAD DETENIDA CON IGNICION
      }
      if (vehicle.m2h > 0) {
        clearTimeout(vehicle.m2h);
        vehicle.m2h = 0;
      }
      vehicle.m2h = setTimeout(() => {
        // //console.log("MAS DE 2 HORAS SIN TRANSMISION : " + item.name);
        vehicle.c_02 = moment(new Date()).diff(
          moment(new Date(vehicle.dt_tracker.replace(/-/g, '/'))),
          'seconds'
        );
        if (vehicle.c_02 >= 7200 && vehicle.v_on == 0) {
          vehicle.point_color = 40; //NEGRO - UNIDAD SIN TRANSMISION
        }
        vehicle.m2h = 0;
      }, (7200 - vehicle.c_01) * 1000);
    }
    return vehicle;
  }
  private addPointColorUser445(vehicle: any) {
    if (vehicle.c_01 >= 7200) {
      vehicle.point_color = 40; //grey
    } else {
      if (vehicle.v_vel <= 3) {
        vehicle.point_color = 20; //grey
      } else if (vehicle.v_vel > 3 && vehicle.v_on == 0) {
        vehicle.point_color = 10; //grey
      }
      if (vehicle.m2h > 0) {
        clearTimeout(vehicle.m2h);
        vehicle.m2h = 0;
      }
      vehicle.m2h = setTimeout(() => {
        vehicle.c_02 = moment(new Date()).diff(
          moment(new Date(vehicle.dt_tracker.replace(/-/g, '/'))),
          'seconds'
        );
        if (vehicle.c_02 >= 7200) {
          vehicle.point_color = 40; //grey
        }
        vehicle.m2h = 0;
      }, (7200 - vehicle.c_01) * 1000);
    }
    return vehicle;
  }

  private addVel(vehicle: any) {
    if (this.statusDataVehicle == false) {
      vehicle.speed = 0;
    }
    const v_gps = vehicle.speed;
    vehicle.v_sat = Number(vehicle.parametrosGet['sat']);
    const v_di1 = vehicle.parametrosGet['di1'];
    let v_di4 = vehicle.parametrosGet['di4'];
    if (v_di4 == undefined) {
      v_di4 = vehicle.parametrosGet['Custom_ign'];
    }
    const v_acv = vehicle.parametrosGet['acv'];
    const v_accv = vehicle.parametrosGet['accv'];

    const a_01 = moment(new Date(vehicle.dt_tracker.replace(/-/g, '/')));
    const b_01 = moment(new Date());
    const c_01 = b_01.diff(a_01, 'seconds');

    vehicle.c_01 = c_01;
    vehicle.v_vel = v_gps;

    if (vehicle.tipoGps == 'ruptela') {
      var v_can = vehicle.parametrosGet['can_speed'];
      var v_spd = vehicle.parametrosGet['GPS speed'];
      var v_eco = vehicle.parametrosGet['ECO_max_speed'];

      if (typeof v_can !== undefined && v_can > 10) {
        vehicle.v_vel = v_can;
      } else if (typeof v_spd !== undefined) {
        vehicle.v_vel = v_spd;
      } else if (
        typeof v_eco !== undefined &&
        v_eco < 110 &&
        v_gps - 10 < v_eco &&
        v_gps + 10 > v_eco
      ) {
        vehicle.v_vel = v_eco;
      } else {
        vehicle.v_vel = v_gps;
      }

      vehicle.v_on = v_di4;
      vehicle.v_ac = v_acv;
    } else if (vehicle.tipoGps == 'teltonika') {
      vehicle.v_on = v_di4;
      vehicle.v_ac = v_accv;
    } else if (vehicle.tipoGps == 'avl') {
      vehicle.v_sat = 1;
      vehicle.v_on = 1;
      vehicle.v_ac = 5;
    } else if (vehicle.tipoGps == 'cipia') {
      if (vehicle.parametrosGet['event'] == 'IgnitionOFF') {
        vehicle.v_on = 0;
      } else {
        vehicle.v_on = 1;
      }
    }

    return vehicle;
  }

  private addSignal(vehicle: any) {
    vehicle.dt_server = this.toLocal(vehicle.dt_server, true);
    const diffHours: number = this.getUTCOffset(
      vehicle.dt_server
    );
    vehicle['señal_gps'] = -1 * diffHours;
    vehicle['señal_gsm'] = -1 * diffHours;
    vehicle.timer = 0;
    return vehicle;
  }

  private addTypeGps(params: any) {
    if (params.indexOf('ruptela') !== -1) {
      return 'ruptela';
    } else if (params.indexOf('teltonika') !== -1) {
      return 'teltonika';
    } else if (params.indexOf('avl') !== -1) {
      return 'avl';
    } else if (params.indexOf('cipia') !== -1) {
      return 'cipia';
    } else {
      return '';
    }
  }

  private addParams(params: any) {
    var arrayParam = params.split('|');
    var paramsObj = [];

    for (var j = 0; j < arrayParam.length; j++) {
      if (arrayParam[j].indexOf('=') > -1) {
        var temp = arrayParam[j].split('=');
        temp[0] = temp[0].trim();
        temp[1] = temp[1].trim();
        // arrayR.push(di1[0]);
        if (isNaN(temp[1])) {
          paramsObj[temp[0]] = temp[1];
        } else {
          paramsObj[temp[0]] = parseFloat(temp[1]);
        }
        // arrayP.push(di1);
      }
      if (arrayParam[j].indexOf(':') > -1) {
        var temp = arrayParam[j].split(':');
        temp[0] = temp[0].trim();
        temp[1] = temp[1].trim();
        if (isNaN(temp[1])) {
          paramsObj[temp[0]] = temp[1];
        } else {
          paramsObj[temp[0]] = parseFloat(temp[1]);
        }
      }
    }

    return paramsObj;
  }

  private addSelect(vehicle: any) {
    // console.log('UPDATE in addSelect vehicle->',vehicle);

    if (this.statusDataVehicle == false) {
      vehicle.follow = false;
      vehicle.tag = true;
      vehicle.eye = true;
      vehicle.tag_driver = false;
    }
    // else{ //EN DUDA SI VA SEGUIR ESTA COSA
    //   vehicle.eye = true;
    // }
    vehicle.paradaDesde = false;
    vehicle.eventos = {};
    // vehicle.dt_server = moment(vehicle.dt_server);

    return vehicle;
  }

  private addTank(vehicle: any) {
    if (vehicle.tanque == 0) {
      vehicle.capacidad_tanque = 0;
      vehicle.capacidad_tanque_text = '0 gal. || 0 l.';
    } else {
      if (vehicle.tanque) {
        const tanqueC = vehicle.tanque.split(',');
        vehicle.capacidad_tanque = parseInt(tanqueC[1]);
        vehicle.capacidad_tanque_text =
          vehicle.capacidad_tanque +
          ' gal. || ' +
          (vehicle.capacidad_tanque * 3.7854118).toFixed(2) +
          ' l.';
      }
    }
    return vehicle;
  }

}

